// AUTO-GENERATED from the Manufacturing Collaboration workbooks:
//   Manufacturing_Collaboration_-_Lentiviral_Vector_2388-OXB-A-1.xlsx
//   Manufacturing_Collaboration_-_Lentiviral_Vector_2785-OXB-B-1.xlsx
// One dataset per Manufacturing tab, keyed by batch number. Procedure Number is
// built as "Unit Procedure No.Operation No.Phase No" (e.g. "3.4.1"). Any batch
// other than these two falls back to a representative dataset (2388) whose
// batch-number token is remapped to the row's own batch (see selectTabData).

import moment from 'moment';

// Accepted input date shapes: raw API ISO ("2026-01-31T00:00[:00]"), already-
// formatted Excel dates ("09-MAY-2025"), or Excel date+time ("26-APR-2025 10:27").
const DATE_INPUT_FORMATS = [
  moment.ISO_8601,
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm',
  'YYYY-MM-DD',
  'DD-MMM-YYYY HH:mm',
  'DD-MMM-YYYY',
];

// Normalize any of the above to the design's "DD-MMM-YYYY" (uppercase). Unknown/
// non-date strings pass through unchanged so free text is never mangled.
export const fmtDate = (v) => {
  if (v === null || v === undefined || v === '') return '';
  const m = moment(String(v).trim(), DATE_INPUT_FORMATS, true);
  return m.isValid() ? m.format('DD-MMM-YYYY').toUpperCase() : v;
};

// Same as fmtDate but keeps the time ("DD-MMM-YYYY HH:mm") when the source carries
// a non-midnight time; date-only inputs stay date-only.
export const fmtDateTime = (v) => {
  if (v === null || v === undefined || v === '') return '';
  const s = String(v).trim();
  const m = moment(s, DATE_INPUT_FORMATS, true);
  if (!m.isValid()) return v;
  const hasTime = /[T\s]\d{1,2}:\d{2}/.test(s) && !/T00:00(:00)?$/.test(s);
  return m.format(hasTime ? 'DD-MMM-YYYY HH:mm' : 'DD-MMM-YYYY').toUpperCase();
};

// Same accepted inputs as above but also with seconds ("... HH:mm:ss"), used for
// the Planning tab's summary + "Last Update" timestamps which carry seconds.
const DATE_INPUT_FORMATS_SEC = [
  moment.ISO_8601,
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm',
  'YYYY-MM-DD',
  'DD-MMM-YYYY HH:mm:ss',
  'DD-MMM-YYYY HH:mm',
  'DD-MMM-YYYY',
];

// Normalize a timestamp to "DD-MMM-YYYY HH:mm:ss" (seconds kept when the source has
// a non-midnight time); date-only / non-date inputs pass through unchanged.
export const fmtDateTimeSec = (v) => {
  if (v === null || v === undefined || v === '') return '';
  const s = String(v).trim();
  const m = moment(s, DATE_INPUT_FORMATS_SEC, true);
  if (!m.isValid()) return v;
  const hasTime = /[T\s]\d{1,2}:\d{2}/.test(s) && !/T00:00(:00)?$/.test(s);
  return m.format(hasTime ? 'DD-MMM-YYYY HH:mm:ss' : 'DD-MMM-YYYY').toUpperCase();
};

export const MATERIALS_DATA = {
  "TZB2401-DS": [
    {
      "timestampFrom": "5-Jan-2026 9:45:00",
      "timeTo": "5-Jan-2026 11:00:00",
      "procedureNumber": "1.1.1",
      "unitName": "T-flasks / shake flasks (Cell Expansion Suite)",
      "unitProcedure": "Cell Thaw & Seed Expansion",
      "operation": "MWCB Thaw & Seed",
      "phase": "Retrieve MWCB vial (CHO DUKX-B11) & thaw — MWCB vial charge; spec 2 EA (target); result: 2 EA",
      "materialDescription": "CHO DUKX-B11 Working Cell Bank (WCB), 1 mL vial - cell thaw & seed inoculation",
      "cmoMaterialCode": "TZB-001-2",
      "cmoBatchNumber": "MBAT-001",
      "targetQuantity": "2",
      "actualQuantity": "2",
      "uom": "EA",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "10-Jan-2026 9:00:00",
      "timeTo": "12-Jan-2026 0:00:00",
      "procedureNumber": "3.1.1",
      "unitName": "2000 L SS fed-batch BR-202 (PBR-104)",
      "unitProcedure": "Production Bioreactor Culture",
      "operation": "Culture establishment & control",
      "phase": "Agitation speed — CPP · SP 120; spec 100 – 140 RPM; result: 118 RPM",
      "materialDescription": "CD CHO Production Medium - production bioreactor charge",
      "cmoMaterialCode": "TZB-007-2",
      "cmoBatchNumber": "MBAT-009",
      "targetQuantity": "1800",
      "actualQuantity": "1815",
      "uom": "L",
      "quantityVariance": "0.83%"
    },
    {
      "timestampFrom": "13-Jan-2026 9:00:00",
      "timeTo": "21-Jan-2026 12:00:00",
      "procedureNumber": "3.2.1",
      "unitName": "2000 L SS fed-batch BR-202 (PBR-104)",
      "unitProcedure": "Production Bioreactor Culture",
      "operation": "Fed-batch feeding & culture",
      "phase": "Temperature control + Feed Medium A (Day 1–7) — CPP temp SP 37 · Feed A charge · cycle 7 d; spec 36.5 – 37.5 °C; result: 36.90 °C · Feed A 181 L · 7 d",
      "materialDescription": "CHO Feed Medium A (concentrated nutrient feed) - fed-batch bolus feed (Days 3-11)",
      "cmoMaterialCode": "TZB-008-2",
      "cmoBatchNumber": "MBAT-010",
      "targetQuantity": "180",
      "actualQuantity": "181",
      "uom": "L",
      "quantityVariance": "0.56%"
    },
    {
      "timestampFrom": "13-Jan-2026 9:00:00",
      "timeTo": "21-Jan-2026 12:00:00",
      "procedureNumber": "3.2.2",
      "unitName": "2000 L SS fed-batch BR-202 (PBR-104)",
      "unitProcedure": "Production Bioreactor Culture",
      "operation": "Fed-batch feeding & culture",
      "phase": "Feed Medium B addition (Day 8–14) — Feed B charge · cycle 5 d; result: Feed B 36.4 L · 5 d",
      "materialDescription": "CHO Feed Medium B (amino acid concentrate) - fed-batch bolus feed (Days 3-11)",
      "cmoMaterialCode": "TZB-009-2",
      "cmoBatchNumber": "MBAT-011",
      "targetQuantity": "36",
      "actualQuantity": "36.4",
      "uom": "L",
      "quantityVariance": "1.11%"
    },
    {
      "timestampFrom": "26-Jan-2026 10:30:00",
      "timeTo": "27-Jan-2026 0:00:00",
      "procedureNumber": "5.1.1",
      "unitName": "MabSelect SuRe Protein A skid (CHR-301)",
      "unitProcedure": "Protein A Affinity Chromatography (Capture)",
      "operation": "Column prep & equilibration",
      "phase": "Charge MabSelect SuRe resin / equilibrate — Resin charge; spec 28 L (target); result: 28 L",
      "materialDescription": "MabSelect SuRe Protein A Resin - capture column pack",
      "cmoMaterialCode": "TZB-017-2",
      "cmoBatchNumber": "MBAT-019",
      "targetQuantity": "28",
      "actualQuantity": "28",
      "uom": "L",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "31-Jan-2026 8:00:00",
      "timeTo": "31-Jan-2026 12:00:00",
      "procedureNumber": "10.1.1",
      "unitName": "Formulation vessel (FMV-401)",
      "unitProcedure": "Formulation",
      "operation": "Buffer / protein adjust",
      "phase": "Add L-Histidine + confirm protein conc. — Histidine charge · IPC protein conc; spec 19.0 – 21.0 g/L; result: 0.598 kg · 20.1 g/L (Pass)",
      "materialDescription": "L-Histidine (Ph. Eur. / USP, compendial grade) - formulation buffer component",
      "cmoMaterialCode": "TZB-033-2",
      "cmoBatchNumber": "MBAT-035",
      "targetQuantity": "0.598",
      "actualQuantity": "0.598",
      "uom": "KG",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "31-Jan-2026 8:00:00",
      "timeTo": "31-Jan-2026 12:00:00",
      "procedureNumber": "10.1.2",
      "unitName": "Formulation vessel (FMV-401)",
      "unitProcedure": "Formulation",
      "operation": "Buffer / protein adjust",
      "phase": "Add L-Histidine HCl + confirm pH — His-HCl charge · IPC pH; spec 5.80 – 6.20; result: 0.918 kg · 6.04 (Pass)",
      "materialDescription": "L-Histidine Hydrochloride Monohydrate (USP) - formulation buffer component",
      "cmoMaterialCode": "TZB-034-2",
      "cmoBatchNumber": "MBAT-036",
      "targetQuantity": "0.918",
      "actualQuantity": "0.918",
      "uom": "KG",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "31-Jan-2026 12:00:00",
      "timeTo": "31-Jan-2026 16:00:00",
      "procedureNumber": "10.2.1",
      "unitName": "Formulation vessel (FMV-401)",
      "unitProcedure": "Formulation",
      "operation": "Excipient addition",
      "phase": "Add α,α-trehalose dihydrate — Trehalose charge; spec 21.780 kg (target); result: 21.780 kg",
      "materialDescription": "alpha,alpha-Trehalose Dihydrate (USP, Ph. Eur.) - formulation excipient (stabilizer)",
      "cmoMaterialCode": "TZB-035-2",
      "cmoBatchNumber": "MBAT-037",
      "targetQuantity": "21.78",
      "actualQuantity": "21.78",
      "uom": "KG",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "31-Jan-2026 12:00:00",
      "timeTo": "31-Jan-2026 16:00:00",
      "procedureNumber": "10.2.2",
      "unitName": "Formulation vessel (FMV-401)",
      "unitProcedure": "Formulation",
      "operation": "Excipient addition",
      "phase": "Add polysorbate 20 — PS20 charge; spec 0.103 kg (target); result: 0.103 kg",
      "materialDescription": "Polysorbate 20 (NF, multi-compendial) - formulation excipient (surfactant)",
      "cmoMaterialCode": "TZB-036-2",
      "cmoBatchNumber": "MBAT-038",
      "targetQuantity": "0.103",
      "actualQuantity": "0.103",
      "uom": "KG",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "1-Feb-2026 8:00:00",
      "timeTo": "1-Feb-2026 16:30:00",
      "procedureNumber": "11.1.1",
      "unitName": "DS bag fill rig (BFR-501) + controlled-rate freezer (FRZ-701)",
      "unitProcedure": "DS Aseptic Bag Fill & Freeze",
      "operation": "Aseptic bag fill",
      "phase": "Fill 30 × 1 L bags + weight check — Bag charge · IPC fill wt · Deviation QE-2026-020 (Major, Closed); spec 1.000 ± 0.020 kg; result: 30 bags · 1.005 kg (Pass); #21–23 OOT low",
      "materialDescription": "Sartorius Flexsafe 2D 1 L Bag, EVA film, gamma-irr. - DS aseptic bag fill",
      "cmoMaterialCode": "TZB-040-2",
      "cmoBatchNumber": "MBAT-041",
      "targetQuantity": "30",
      "actualQuantity": "30",
      "uom": "EA",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "1-Feb-2026 8:00:00",
      "timeTo": "1-Feb-2026 16:30:00",
      "procedureNumber": "11.1.2",
      "unitName": "DS bag fill rig (BFR-501) + controlled-rate freezer (FRZ-701)",
      "unitProcedure": "DS Aseptic Bag Fill & Freeze",
      "operation": "Aseptic bag fill",
      "phase": "Connect single-use manifold assembly — Manifold charge; spec 3 EA (target); result: 3 EA",
      "materialDescription": "Single-Use Manifold Assembly (10-bag, sterile) - DS aseptic bag fill (fluid path)",
      "cmoMaterialCode": "TZB-041-2",
      "cmoBatchNumber": "MBAT-042",
      "targetQuantity": "3",
      "actualQuantity": "3",
      "uom": "EA",
      "quantityVariance": "0.00%"
    }
  ],
  "2388-OXB-A-1": [
    {
      "timestampFrom": "26-APR-2025 10:27",
      "timeTo": "09-MAY-2025 12:00",
      "procedureNumber": "1.1.3",
      "unitName": "Shaker flasks / CO₂ incubators",
      "unitProcedure": "Cell thaw & shake-flask expansion (CSP0–CSP3)",
      "operation": "Cell thaw (WCB vial) & shake-flask seed",
      "phase": "Material addition: Media D (serum-free HEK293 suspension medium) - shake-flask expansion",
      "materialDescription": "Media D (serum-free HEK293 suspension medium) - shake-flask expansion",
      "cmoMaterialCode": "LVV-004-4",
      "cmoBatchNumber": "MBAT-101",
      "targetQuantity": "6",
      "actualQuantity": "6.05",
      "uom": "L",
      "quantityVariance": "0.83%"
    },
    {
      "timestampFrom": "12-MAY-2025 15:44",
      "timeTo": "14-MAY-2025 10:00",
      "procedureNumber": "3.1.1",
      "unitName": "GMP6_STR200 — 200 L production bioreactor + KTF perfusion skid",
      "unitProcedure": "Production bioreactor (200 L): expansion, perfusion, transfection, induction, harvest",
      "operation": "Production bioreactor setup, media & parameter control (200 L)",
      "phase": "Material addition: Media D - 200 L SUB cell expansion & Perfusion A",
      "materialDescription": "Media D - 200 L SUB cell expansion & Perfusion A",
      "cmoMaterialCode": "LVV-004-4",
      "cmoBatchNumber": "MBAT-102",
      "targetQuantity": "200",
      "actualQuantity": "202",
      "uom": "L",
      "quantityVariance": "1.00%"
    },
    {
      "timestampFrom": "14-MAY-2025 13:00",
      "timeTo": "14-MAY-2025 15:27",
      "procedureNumber": "3.4.2",
      "unitName": "GMP6_STR200 — 200 L production bioreactor + KTF perfusion skid",
      "unitProcedure": "Production bioreactor (200 L): expansion, perfusion, transfection, induction, harvest",
      "operation": "Transfection (complex addition)",
      "phase": "Material addition: Transfection complex (U1 plasmid(s) + PEIpro)",
      "materialDescription": "Transfection complex (U1 plasmid(s) + PEIpro)",
      "cmoMaterialCode": "LVV-010-4",
      "cmoBatchNumber": "MBAT-110",
      "targetQuantity": "0.9",
      "actualQuantity": "0.91",
      "uom": "g",
      "quantityVariance": "1.11%"
    },
    {
      "timestampFrom": "15-MAY-2025 09:34",
      "timeTo": "15-MAY-2025 17:34",
      "procedureNumber": "3.6.1",
      "unitName": "GMP6_STR200 — 200 L production bioreactor + KTF perfusion skid",
      "unitProcedure": "Production bioreactor (200 L): expansion, perfusion, transfection, induction, harvest",
      "operation": "Perfusion B",
      "phase": "In-line control / measurement: Perfusion B duration",
      "materialDescription": "Media D containing sodium butyrate - Perfusion B",
      "cmoMaterialCode": "LVV-004-4",
      "cmoBatchNumber": "MBAT-103",
      "targetQuantity": "60",
      "actualQuantity": "60.3",
      "uom": "L",
      "quantityVariance": "0.50%"
    },
    {
      "timestampFrom": "15-MAY-2025 08:00",
      "timeTo": "15-MAY-2025 08:42",
      "procedureNumber": "3.7.2",
      "unitName": "GMP6_STR200 — 200 L production bioreactor + KTF perfusion skid",
      "unitProcedure": "Production bioreactor (200 L): expansion, perfusion, transfection, induction, harvest",
      "operation": "Induction (sodium butyrate)",
      "phase": "Material addition: Sodium butyrate (induction)",
      "materialDescription": "Sodium butyrate (induction)",
      "cmoMaterialCode": "LVV-020-4",
      "cmoBatchNumber": "MBAT-120",
      "targetQuantity": "2",
      "actualQuantity": "2.03",
      "uom": "L",
      "quantityVariance": "1.50%"
    },
    {
      "timestampFrom": "15-MAY-2025 17:30",
      "timeTo": "16-MAY-2025 09:50",
      "procedureNumber": "4.1.1",
      "unitName": "Clarification / depth-filtration skid",
      "unitProcedure": "Rapid harvest, Benzonase treatment & 0.2 µm clarification",
      "operation": "Benzonase nuclease treatment (harvest)",
      "phase": "Material addition: MgCl2 + Benzonase (harvest nuclease treatment)",
      "materialDescription": "MgCl2 + Benzonase (harvest nuclease treatment)",
      "cmoMaterialCode": "LVV-030-4",
      "cmoBatchNumber": "MBAT-130",
      "targetQuantity": "1.2",
      "actualQuantity": "1.21",
      "uom": "L",
      "quantityVariance": "0.83%"
    },
    {
      "timestampFrom": "16-MAY-2025 12:06",
      "timeTo": "16-MAY-2025 14:08",
      "procedureNumber": "4.2.1",
      "unitName": "Clarification / depth-filtration skid",
      "unitProcedure": "Rapid harvest, Benzonase treatment & 0.2 µm clarification",
      "operation": "Clarification (0.2 µm)",
      "phase": "In-line control / measurement: Clarification pump speed",
      "materialDescription": "Buffer A (clarification equilibration / flush)",
      "cmoMaterialCode": "LVV-040-4",
      "cmoBatchNumber": "MBAT-140",
      "targetQuantity": "50",
      "actualQuantity": "50.4",
      "uom": "L",
      "quantityVariance": "0.80%"
    },
    {
      "timestampFrom": "16-MAY-2025 17:00",
      "timeTo": "16-MAY-2025 19:30",
      "procedureNumber": "5.1.1",
      "unitName": "CEX chromatography skid (Sartobind S)",
      "unitProcedure": "Cation-exchange chromatography (CIEX, Sartobind S)",
      "operation": "Chromatography skid setup & buffer preparation",
      "phase": "Material addition: Buffer A to E (AIEX gradient set)",
      "materialDescription": "Buffer A to E (AIEX gradient set)",
      "cmoMaterialCode": "LVV-042-4",
      "cmoBatchNumber": "MBAT-142",
      "targetQuantity": "35",
      "actualQuantity": "35.2",
      "uom": "L",
      "quantityVariance": "0.57%"
    },
    {
      "timestampFrom": "16-MAY-2025 14:30",
      "timeTo": "16-MAY-2025 16:30",
      "procedureNumber": "6.1.1",
      "unitName": "AEX chromatography skid (Sartobind Q)",
      "unitProcedure": "Anion-exchange chromatography (AIEX, Sartobind Q)",
      "operation": "Chromatography skid setup & buffer preparation",
      "phase": "Material addition: Buffer A and D (CIEX equilibration & elution)",
      "materialDescription": "Buffer A and D (CIEX equilibration & elution)",
      "cmoMaterialCode": "LVV-041-4",
      "cmoBatchNumber": "MBAT-141",
      "targetQuantity": "40",
      "actualQuantity": "40.3",
      "uom": "L",
      "quantityVariance": "0.75%"
    },
    {
      "timestampFrom": "16-MAY-2025 20:45",
      "timeTo": "17-MAY-2025 01:13",
      "procedureNumber": "7.1.1",
      "unitName": "HFF / TFF skid (+ SAN mixing)",
      "unitProcedure": "SAN nuclease polish & hollow-fibre UF/DF",
      "operation": "SAN nuclease polish",
      "phase": "Material addition: MgCl2 + SAN (nuclease polish)",
      "materialDescription": "MgCl2 + SAN (nuclease polish)",
      "cmoMaterialCode": "LVV-031-4",
      "cmoBatchNumber": "MBAT-131",
      "targetQuantity": "0.5",
      "actualQuantity": "0.5",
      "uom": "L",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "17-MAY-2025 01:29",
      "timeTo": "17-MAY-2025 02:45",
      "procedureNumber": "7.4.1",
      "unitName": "HFF / TFF skid (+ SAN mixing)",
      "unitProcedure": "SAN nuclease polish & hollow-fibre UF/DF",
      "operation": "HFF — diafiltration (DF) & UDFD pool",
      "phase": "HFF diafiltration retentate (CPP: HFF diafiltration TMP, HFF diafiltration duration, HFF diafiltration final permeate weight)",
      "materialDescription": "TSSM formulation buffer (diafiltration / formulation)",
      "cmoMaterialCode": "LVV-050-4",
      "cmoBatchNumber": "MBAT-150",
      "targetQuantity": "8",
      "actualQuantity": "8.05",
      "uom": "L",
      "quantityVariance": "0.63%"
    }
  ],
  "2785-OXB-B-1": [
    {
      "timestampFrom": "26-SEP-2025 10:21",
      "timeTo": "10-OCT-2025 12:00",
      "procedureNumber": "1.1.3",
      "unitName": "Shaker flasks / CO₂ incubators",
      "unitProcedure": "Cell thaw & shake-flask expansion (CSP0–CSP3)",
      "operation": "Cell thaw (WCB vial) & shake-flask seed",
      "phase": "Material addition: Media D (serum-free HEK293 suspension medium) - shake-flask expansion",
      "materialDescription": "Media D (serum-free HEK293 suspension medium) - shake-flask expansion",
      "cmoMaterialCode": "LVV-004-4",
      "cmoBatchNumber": "MBAT-201",
      "targetQuantity": "6",
      "actualQuantity": "6.1",
      "uom": "L",
      "quantityVariance": "2.00%"
    },
    {
      "timestampFrom": "13-OCT-2025 15:51",
      "timeTo": "15-OCT-2025 10:00",
      "procedureNumber": "3.1.1",
      "unitName": "GMP6_STR200 — 200 L production bioreactor + KTF perfusion skid",
      "unitProcedure": "Production bioreactor (200 L): expansion, perfusion, transfection, induction, harvest",
      "operation": "Production bioreactor setup, media & parameter control (200 L)",
      "phase": "Material addition: Media D - 200 L SUB cell expansion & Perfusion A",
      "materialDescription": "Media D - 200 L SUB cell expansion & Perfusion A",
      "cmoMaterialCode": "LVV-004-4",
      "cmoBatchNumber": "MBAT-202",
      "targetQuantity": "200",
      "actualQuantity": "201.5",
      "uom": "L",
      "quantityVariance": "1.00%"
    },
    {
      "timestampFrom": "15-OCT-2025 13:00",
      "timeTo": "15-OCT-2025 14:42",
      "procedureNumber": "3.4.2",
      "unitName": "GMP6_STR200 — 200 L production bioreactor + KTF perfusion skid",
      "unitProcedure": "Production bioreactor (200 L): expansion, perfusion, transfection, induction, harvest",
      "operation": "Transfection (complex addition)",
      "phase": "Material addition: Transfection complex (U1 plasmid(s) + PEIpro)",
      "materialDescription": "Transfection complex (U1 plasmid(s) + PEIpro)",
      "cmoMaterialCode": "LVV-010-4",
      "cmoBatchNumber": "MBAT-210",
      "targetQuantity": "0.9",
      "actualQuantity": "0.9",
      "uom": "g",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "16-OCT-2025 08:53",
      "timeTo": "16-OCT-2025 16:53",
      "procedureNumber": "3.6.1",
      "unitName": "GMP6_STR200 — 200 L production bioreactor + KTF perfusion skid",
      "unitProcedure": "Production bioreactor (200 L): expansion, perfusion, transfection, induction, harvest",
      "operation": "Perfusion B",
      "phase": "In-line control / measurement: Perfusion B duration",
      "materialDescription": "Media D containing sodium butyrate - Perfusion B",
      "cmoMaterialCode": "LVV-004-4",
      "cmoBatchNumber": "MBAT-203",
      "targetQuantity": "60",
      "actualQuantity": "60.5",
      "uom": "L",
      "quantityVariance": "1.00%"
    },
    {
      "timestampFrom": "16-OCT-2025 08:00",
      "timeTo": "16-OCT-2025 08:42",
      "procedureNumber": "3.7.2",
      "unitName": "GMP6_STR200 — 200 L production bioreactor + KTF perfusion skid",
      "unitProcedure": "Production bioreactor (200 L): expansion, perfusion, transfection, induction, harvest",
      "operation": "Induction (sodium butyrate)",
      "phase": "Material addition: Sodium butyrate (induction)",
      "materialDescription": "Sodium butyrate (induction)",
      "cmoMaterialCode": "LVV-020-4",
      "cmoBatchNumber": "MBAT-220",
      "targetQuantity": "2",
      "actualQuantity": "2.02",
      "uom": "L",
      "quantityVariance": "1.00%"
    },
    {
      "timestampFrom": "16-OCT-2025 21:00",
      "timeTo": "17-OCT-2025 13:00",
      "procedureNumber": "4.1.1",
      "unitName": "Clarification / depth-filtration skid",
      "unitProcedure": "Rapid harvest, Benzonase treatment & 0.2 µm clarification",
      "operation": "Benzonase nuclease treatment (harvest)",
      "phase": "Material addition: MgCl2 + Benzonase (harvest nuclease treatment)",
      "materialDescription": "MgCl2 + Benzonase (harvest nuclease treatment)",
      "cmoMaterialCode": "LVV-030-4",
      "cmoBatchNumber": "MBAT-230",
      "targetQuantity": "1.2",
      "actualQuantity": "1.2",
      "uom": "L",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "17-OCT-2025 15:18",
      "timeTo": "17-OCT-2025 17:15",
      "procedureNumber": "4.2.1",
      "unitName": "Clarification / depth-filtration skid",
      "unitProcedure": "Rapid harvest, Benzonase treatment & 0.2 µm clarification",
      "operation": "Clarification (0.2 µm)",
      "phase": "In-line control / measurement: Clarification pump speed",
      "materialDescription": "Buffer A (clarification equilibration / flush)",
      "cmoMaterialCode": "LVV-040-4",
      "cmoBatchNumber": "MBAT-240",
      "targetQuantity": "50",
      "actualQuantity": "50.3",
      "uom": "L",
      "quantityVariance": "1.00%"
    },
    {
      "timestampFrom": "17-OCT-2025 19:45",
      "timeTo": "17-OCT-2025 22:00",
      "procedureNumber": "5.1.1",
      "unitName": "CEX chromatography skid (Sartobind S)",
      "unitProcedure": "Cation-exchange chromatography (CIEX, Sartobind S)",
      "operation": "Chromatography skid setup & buffer preparation",
      "phase": "Material addition: Buffer A to E (AIEX gradient set)",
      "materialDescription": "Buffer A to E (AIEX gradient set)",
      "cmoMaterialCode": "LVV-042-4",
      "cmoBatchNumber": "MBAT-242",
      "targetQuantity": "35",
      "actualQuantity": "35.1",
      "uom": "L",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "17-OCT-2025 17:30",
      "timeTo": "17-OCT-2025 19:15",
      "procedureNumber": "6.1.1",
      "unitName": "AEX chromatography skid (Sartobind Q)",
      "unitProcedure": "Anion-exchange chromatography (AIEX, Sartobind Q)",
      "operation": "Chromatography skid setup & buffer preparation",
      "phase": "Material addition: Buffer A and D (CIEX equilibration & elution)",
      "materialDescription": "Buffer A and D (CIEX equilibration & elution)",
      "cmoMaterialCode": "LVV-041-4",
      "cmoBatchNumber": "MBAT-241",
      "targetQuantity": "40",
      "actualQuantity": "40.2",
      "uom": "L",
      "quantityVariance": "1.00%"
    },
    {
      "timestampFrom": "17-OCT-2025 22:14",
      "timeTo": "17-OCT-2025 23:18",
      "procedureNumber": "7.1.1",
      "unitName": "HFF / TFF skid (+ SAN mixing)",
      "unitProcedure": "SAN nuclease polish & hollow-fibre UF/DF",
      "operation": "SAN nuclease polish",
      "phase": "Material addition: MgCl2 + SAN (nuclease polish)",
      "materialDescription": "MgCl2 + SAN (nuclease polish)",
      "cmoMaterialCode": "LVV-031-4",
      "cmoBatchNumber": "MBAT-231",
      "targetQuantity": "0.5",
      "actualQuantity": "0.5",
      "uom": "L",
      "quantityVariance": "0.00%"
    },
    {
      "timestampFrom": "17-OCT-2025 23:36",
      "timeTo": "18-OCT-2025 00:59",
      "procedureNumber": "7.4.1",
      "unitName": "HFF / TFF skid (+ SAN mixing)",
      "unitProcedure": "SAN nuclease polish & hollow-fibre UF/DF",
      "operation": "HFF — diafiltration (DF) & UDFD pool",
      "phase": "HFF diafiltration retentate (CPP: HFF diafiltration TMP, HFF diafiltration duration, HFF diafiltration final permeate weight)",
      "materialDescription": "TSSM formulation buffer (diafiltration / formulation)",
      "cmoMaterialCode": "LVV-050-4",
      "cmoBatchNumber": "MBAT-250",
      "targetQuantity": "8",
      "actualQuantity": "8.1",
      "uom": "L",
      "quantityVariance": "1.00%"
    }
  ]
};

export const INPROCESS_DATA = {
  "TZB2401-DS": [
    {
      "procedureNumber": "1.2.2",
      "operationDescription": "T-flasks / shake flasks: Seed Train Expansion",
      "methodId": "T.07.1.0",
      "sampleDescription": "Seed culture supernatant — Mycoplasma (NAT)",
      "qcReceiptDate": "5-Jan-2026",
      "sampleId": "MYC-IP-001",
      "specificationLimit": "Negative",
      "resultValue": "Negative",
      "uom": "NA",
      "result": "Pass",
      "analyticalReportNumber": "AR-MYC-2026-001"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "2000 L fed-batch STR (production): End of Production",
      "methodId": "T.12.1.0",
      "sampleDescription": "Bioreactor EOP supernatant — Harvest titer (Protein A HPLC)",
      "qcReceiptDate": "24-Jan-2026",
      "sampleId": "TIT-IP-001",
      "specificationLimit": ">= 3.5 g/L",
      "resultValue": "4.2",
      "uom": "g/L",
      "result": "Pass",
      "analyticalReportNumber": "AR-TIT-2026-021"
    },
    {
      "procedureNumber": "3.4.2",
      "operationDescription": "2000 L fed-batch STR (production): End of Production",
      "methodId": "T.08.1.0",
      "sampleDescription": "Bioreactor EOP sample — Bioburden (pre-harvest)",
      "qcReceiptDate": "24-Jan-2026",
      "sampleId": "BIO-IP-002",
      "specificationLimit": "<= 10 CFU/mL",
      "resultValue": "0",
      "uom": "CFU/mL",
      "result": "Pass",
      "analyticalReportNumber": "AR-BIO-2026-019"
    },
    {
      "procedureNumber": "5.2.2",
      "operationDescription": "Protein A affinity chromatography skid: Load & Wash",
      "methodId": "T.17.1.0",
      "sampleDescription": "Protein A eluate pool — Host cell protein (HCP, ELISA)",
      "qcReceiptDate": "27-Jan-2026",
      "sampleId": "HCP-IP-001",
      "specificationLimit": "<= 5000 ppm",
      "resultValue": "1850",
      "uom": "ppm",
      "result": "Pass",
      "analyticalReportNumber": "AR-HCP-2026-027"
    },
    {
      "procedureNumber": "5.3.1",
      "operationDescription": "Protein A affinity chromatography skid: Elute & Pool",
      "methodId": "T.17.2.0",
      "sampleDescription": "Protein A eluate pool — Residual host-cell DNA (qPCR)",
      "qcReceiptDate": "27-Jan-2026",
      "sampleId": "HCD-IP-001",
      "specificationLimit": "<= 100 pg/mg",
      "resultValue": "22",
      "uom": "pg/mg",
      "result": "Pass",
      "analyticalReportNumber": "AR-HCD-2026-028"
    },
    {
      "procedureNumber": "5.3.2",
      "operationDescription": "Protein A affinity chromatography skid: Elute & Pool",
      "methodId": "T.17.3.0",
      "sampleDescription": "Protein A eluate pool — Protein A leachate",
      "qcReceiptDate": "27-Jan-2026",
      "sampleId": "PAL-IP-001",
      "specificationLimit": "<= 20 ppm",
      "resultValue": "4.8",
      "uom": "ppm",
      "result": "Pass",
      "analyticalReportNumber": "AR-PAL-2026-029"
    },
    {
      "procedureNumber": "6.1.1",
      "operationDescription": "Low-pH viral-inactivation tank: Low pH Hold",
      "methodId": "T.10.1.0",
      "sampleDescription": "Post-acid addition pool — pH at low-pH viral inactivation",
      "qcReceiptDate": "27-Jan-2026",
      "sampleId": "PH-IP-002",
      "specificationLimit": "3.30 - 3.70",
      "resultValue": "3.48",
      "uom": "pH",
      "result": "Pass",
      "analyticalReportNumber": "AR-PH-2026-030"
    },
    {
      "procedureNumber": "6.1.2",
      "operationDescription": "Low-pH viral-inactivation tank: Low pH Hold",
      "methodId": "T.18.1.0",
      "sampleDescription": "Inactivation tank record — Hold time at low pH",
      "qcReceiptDate": "27-Jan-2026",
      "sampleId": "VIT-IP-001",
      "specificationLimit": ">= 60 minutes",
      "resultValue": "75",
      "uom": "min",
      "result": "Pass",
      "analyticalReportNumber": "AR-VIT-2026-031"
    },
    {
      "procedureNumber": "8.1.2",
      "operationDescription": "Planova 20N viral-filtration skid: Nanofiltration",
      "methodId": "T.15.7.0",
      "sampleDescription": "Planova 20N post-use — Post-use filter integrity (Planova)",
      "qcReceiptDate": "30-Jan-2026",
      "sampleId": "FILT-IP-003",
      "specificationLimit": "Leakage <= 5 mL/min",
      "resultValue": "1.8",
      "uom": "mL/min",
      "result": "Pass",
      "analyticalReportNumber": "AR-FILT-2026-038"
    },
    {
      "procedureNumber": "7.1.1",
      "operationDescription": "Polishing chromatography skid — CEX (Capto SP ImpRes): Cation Exchange (bind-elute)",
      "methodId": "T.20.1.0",
      "sampleDescription": "CEX eluate pool — Aggregates (SEC-HPLC)",
      "qcReceiptDate": "28-Jan-2026",
      "sampleId": "SEC-IP-001",
      "specificationLimit": "<= 2.0% HMW",
      "resultValue": "0.85",
      "uom": "%",
      "result": "Pass",
      "analyticalReportNumber": "AR-SEC-2026-033"
    },
    {
      "procedureNumber": "7.2.1",
      "operationDescription": "Polishing chromatography skid — CEX (Capto SP ImpRes): CEX Charge-Variant Control",
      "methodId": "T.21.1.0",
      "sampleDescription": "CEX eluate pool — Charge variants (iCIEF)",
      "qcReceiptDate": "28-Jan-2026",
      "sampleId": "ICIEF-IP-001",
      "specificationLimit": "Main 55-75%",
      "resultValue": "65.2",
      "uom": "%",
      "result": "Pass",
      "analyticalReportNumber": "AR-ICIEF-2026-034"
    },
    {
      "procedureNumber": "7.3.2",
      "operationDescription": "Polishing chromatography skid — AEX (Capto Q): Anion Exchange (flow-through)",
      "methodId": "T.22.1.0",
      "sampleDescription": "AEX flow-through pool — Endotoxin (LAL)",
      "qcReceiptDate": "29-Jan-2026",
      "sampleId": "END-IP-001",
      "specificationLimit": "<= 5 EU/mg",
      "resultValue": "0.6",
      "uom": "EU/mg",
      "result": "Pass",
      "analyticalReportNumber": "AR-END-2026-036"
    },
    {
      "procedureNumber": "10.1.1",
      "operationDescription": "Formulation vessel: Buffer / Protein Adjust",
      "methodId": "T.16.1.0",
      "sampleDescription": "Formulated bulk DS — Protein concentration (A280)",
      "qcReceiptDate": "31-Jan-2026",
      "sampleId": "A280-IP-003",
      "specificationLimit": "19.0 - 21.0 g/L",
      "resultValue": "20.1",
      "uom": "g/L",
      "result": "Pass",
      "analyticalReportNumber": "AR-A280-2026-042"
    },
    {
      "procedureNumber": "10.1.2",
      "operationDescription": "Formulation vessel: Buffer / Protein Adjust",
      "methodId": "T.10.1.0",
      "sampleDescription": "Formulated bulk DS — pH (bulk DS)",
      "qcReceiptDate": "31-Jan-2026",
      "sampleId": "PH-IP-004",
      "specificationLimit": "5.80 - 6.20",
      "resultValue": "6.04",
      "uom": "pH",
      "result": "Pass",
      "analyticalReportNumber": "AR-PH-2026-043"
    },
    {
      "procedureNumber": "10.3.1",
      "operationDescription": "Formulation vessel: Pre-Sterile Filtration",
      "methodId": "T.08.1.0",
      "sampleDescription": "Formulated bulk DS — Bioburden (pre-sterile filtration)",
      "qcReceiptDate": "31-Jan-2026",
      "sampleId": "BIO-IP-004",
      "specificationLimit": "<= 10 CFU/100 mL",
      "resultValue": "0",
      "uom": "CFU/100mL",
      "result": "Pass",
      "analyticalReportNumber": "AR-BIO-2026-047"
    },
    {
      "procedureNumber": "10.4.1",
      "operationDescription": "Formulation vessel: Sterile Filter Integrity",
      "methodId": "T.15.6.2",
      "sampleDescription": "0.22 µm Millipak filter — Sterile filter integrity (bubble point)",
      "qcReceiptDate": "31-Jan-2026",
      "sampleId": "FILT-IP-004",
      "specificationLimit": "Bubble Point >= 3.5 bar",
      "resultValue": "4.2",
      "uom": "bar",
      "result": "Pass",
      "analyticalReportNumber": "AR-FILT-2026-048"
    },
    {
      "procedureNumber": "11.1.1",
      "operationDescription": "DS bag fill rig: Aseptic Bag Fill",
      "methodId": "T.30.4.2",
      "sampleDescription": "10 sampled 1 L bags — DS bag fill weight",
      "qcReceiptDate": "1-Feb-2026",
      "sampleId": "BWT-IP-001",
      "specificationLimit": "1.000 +/- 0.020 kg per bag",
      "resultValue": "1.005",
      "uom": "kg",
      "result": "Pass",
      "analyticalReportNumber": "AR-BWT-2026-049"
    },
    {
      "procedureNumber": "11.2.1",
      "operationDescription": "DS bag fill rig: Bag Integrity",
      "methodId": "T.15.8.0",
      "sampleDescription": "Filled bag pre-freeze — Bag integrity (visual + pressure decay)",
      "qcReceiptDate": "1-Feb-2026",
      "sampleId": "BAG-IP-001",
      "specificationLimit": "No leakage; pressure hold pass",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Pass",
      "analyticalReportNumber": "AR-BAG-2026-050"
    },
    {
      "procedureNumber": "11.3.1",
      "operationDescription": "Controlled-rate freezer: Controlled-Rate Freeze",
      "methodId": "T.45.1.0",
      "sampleDescription": "Freezer cycle record — Controlled-rate freeze cycle conformance",
      "qcReceiptDate": "2-Feb-2026",
      "sampleId": "FZ-IP-001",
      "specificationLimit": "Ramp -1 C/min; end -40 C +/- 5",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Pass",
      "analyticalReportNumber": "AR-FZ-2026-051"
    }
  ],
  "2388-OXB-A-1": [
    {
      "procedureNumber": "1.1.4",
      "operationDescription": "Shaker flasks / CO2 incubators: Cell Thaw",
      "methodId": "TM.05.1.0",
      "sampleDescription": "Thawed cell vial (WCB) — Viable cell concentration",
      "qcReceiptDate": "26-APR-2025",
      "sampleId": "IPS-2388-001",
      "specificationLimit": "Report result",
      "resultValue": "2.62 x10^5",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.1.4",
      "operationDescription": "Shaker flasks / CO2 incubators: Cell Thaw",
      "methodId": "TM.05.2.0",
      "sampleDescription": "Thawed cell vial (WCB) — Viability",
      "qcReceiptDate": "26-APR-2025",
      "sampleId": "IPS-2388-001",
      "specificationLimit": ">= 85%",
      "resultValue": "94.5",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.2.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP0",
      "methodId": "TM.05.1.0",
      "sampleDescription": "Shake-flask CSP0 harvest — Viable cell concentration",
      "qcReceiptDate": "29-APR-2025",
      "sampleId": "IPS-2388-002",
      "specificationLimit": "Report result",
      "resultValue": "1.31 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.2.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP0",
      "methodId": "TM.05.2.0",
      "sampleDescription": "Shake-flask CSP0 harvest — Viability",
      "qcReceiptDate": "29-APR-2025",
      "sampleId": "IPS-2388-002",
      "specificationLimit": "Report result",
      "resultValue": "91",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.3.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP1",
      "methodId": "TM.05.1.0",
      "sampleDescription": "Shake-flask CSP1 harvest — Viable cell concentration",
      "qcReceiptDate": "02-MAY-2025",
      "sampleId": "IPS-2388-003",
      "specificationLimit": "Report result",
      "resultValue": "3.08 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.3.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP1",
      "methodId": "TM.05.2.0",
      "sampleDescription": "Shake-flask CSP1 harvest — Viability",
      "qcReceiptDate": "02-MAY-2025",
      "sampleId": "IPS-2388-003",
      "specificationLimit": "Report result",
      "resultValue": "97.8",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.4.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP2",
      "methodId": "TM.05.1.0",
      "sampleDescription": "Shake-flask CSP2 harvest — Viable cell concentration",
      "qcReceiptDate": "06-MAY-2025",
      "sampleId": "IPS-2388-004",
      "specificationLimit": "Report result",
      "resultValue": "4.17 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.4.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP2",
      "methodId": "TM.05.2.0",
      "sampleDescription": "Shake-flask CSP2 harvest — Viability",
      "qcReceiptDate": "06-MAY-2025",
      "sampleId": "IPS-2388-004",
      "specificationLimit": "Report result",
      "resultValue": "92.7",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.5.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP3",
      "methodId": "TM.05.1.0",
      "sampleDescription": "Shake-flask CSP3 harvest — Viable cell concentration",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-005",
      "specificationLimit": "Report result",
      "resultValue": "2.48 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.5.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP3",
      "methodId": "TM.05.2.0",
      "sampleDescription": "Shake-flask CSP3 harvest — Viability",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-005",
      "specificationLimit": "Report result",
      "resultValue": "98.1",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.6.1",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage 4 (P4) — prepare N-1 inoculum",
      "methodId": "TM.05.1.0",
      "sampleDescription": "P4 inoculum (N-1 seed) — Viable cell concentration",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-023",
      "specificationLimit": "Report result",
      "resultValue": "322000",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.6.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage 4 (P4) — prepare N-1 inoculum",
      "methodId": "TM.05.2.0",
      "sampleDescription": "P4 inoculum (N-1 seed) — Viability",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-023",
      "specificationLimit": ">= 85%",
      "resultValue": "97.9",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.2.2",
      "operationDescription": "50 L single-use STR: Inoculation (Day 0)",
      "methodId": "TM.05.1.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Viable cell concentration",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-006",
      "specificationLimit": "Report result",
      "resultValue": "3.22 x10^5",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.2.2",
      "operationDescription": "50 L single-use STR: Inoculation (Day 0)",
      "methodId": "TM.05.2.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Viability",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-006",
      "specificationLimit": "Report result",
      "resultValue": "97.9",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.2",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.05.1.0",
      "sampleDescription": "50 L culture broth, Day 1 — Viable cell concentration",
      "qcReceiptDate": "10-MAY-2025",
      "sampleId": "IPS-2388-007",
      "specificationLimit": "Report result",
      "resultValue": "6.73 x10^5",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.2",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.05.2.0",
      "sampleDescription": "50 L culture broth, Day 1 — Viability",
      "qcReceiptDate": "10-MAY-2025",
      "sampleId": "IPS-2388-007",
      "specificationLimit": "Report result",
      "resultValue": "99.1",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.3",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.05.1.0",
      "sampleDescription": "50 L culture broth, Day 2 — Viable cell concentration",
      "qcReceiptDate": "11-MAY-2025",
      "sampleId": "IPS-2388-008",
      "specificationLimit": "Report result",
      "resultValue": "1.60 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.3",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.05.2.0",
      "sampleDescription": "50 L culture broth, Day 2 — Viability",
      "qcReceiptDate": "11-MAY-2025",
      "sampleId": "IPS-2388-008",
      "specificationLimit": "Report result",
      "resultValue": "99.4",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.1.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Glucose",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-006",
      "specificationLimit": "Report result",
      "resultValue": "N/A",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.2.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Lactate",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-006",
      "specificationLimit": "Report result",
      "resultValue": "2",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.3.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — pCO2",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-006",
      "specificationLimit": "Report result",
      "resultValue": "51",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.4.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Na+",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-006",
      "specificationLimit": "Report result",
      "resultValue": "98.9",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.5.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — K+",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-006",
      "specificationLimit": "Report result",
      "resultValue": "3.53",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.6.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Ca++",
      "qcReceiptDate": "09-MAY-2025",
      "sampleId": "IPS-2388-006",
      "specificationLimit": "Report result",
      "resultValue": "0.31",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.1.0",
      "sampleDescription": "50 L culture broth, Day 1 — Glucose",
      "qcReceiptDate": "10-MAY-2025",
      "sampleId": "IPS-2388-007",
      "specificationLimit": "Report result",
      "resultValue": "N/A",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.2.0",
      "sampleDescription": "50 L culture broth, Day 1 — Lactate",
      "qcReceiptDate": "10-MAY-2025",
      "sampleId": "IPS-2388-007",
      "specificationLimit": "Report result",
      "resultValue": "4.6",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.3.0",
      "sampleDescription": "50 L culture broth, Day 1 — pCO2",
      "qcReceiptDate": "10-MAY-2025",
      "sampleId": "IPS-2388-007",
      "specificationLimit": "Report result",
      "resultValue": "51.6",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.4.0",
      "sampleDescription": "50 L culture broth, Day 1 — Na+",
      "qcReceiptDate": "10-MAY-2025",
      "sampleId": "IPS-2388-007",
      "specificationLimit": "Report result",
      "resultValue": "99",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.5.0",
      "sampleDescription": "50 L culture broth, Day 1 — K+",
      "qcReceiptDate": "10-MAY-2025",
      "sampleId": "IPS-2388-007",
      "specificationLimit": "Report result",
      "resultValue": "3.43",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.6.0",
      "sampleDescription": "50 L culture broth, Day 1 — Ca++",
      "qcReceiptDate": "10-MAY-2025",
      "sampleId": "IPS-2388-007",
      "specificationLimit": "Report result",
      "resultValue": "0.33",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.1.0",
      "sampleDescription": "50 L culture broth, Day 2 — Glucose",
      "qcReceiptDate": "11-MAY-2025",
      "sampleId": "IPS-2388-008",
      "specificationLimit": "Report result",
      "resultValue": "N/A",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.2.0",
      "sampleDescription": "50 L culture broth, Day 2 — Lactate",
      "qcReceiptDate": "11-MAY-2025",
      "sampleId": "IPS-2388-008",
      "specificationLimit": "Report result",
      "resultValue": "4.6",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.3.0",
      "sampleDescription": "50 L culture broth, Day 2 — pCO2",
      "qcReceiptDate": "11-MAY-2025",
      "sampleId": "IPS-2388-008",
      "specificationLimit": "Report result",
      "resultValue": "51.6",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.4.0",
      "sampleDescription": "50 L culture broth, Day 2 — Na+",
      "qcReceiptDate": "11-MAY-2025",
      "sampleId": "IPS-2388-008",
      "specificationLimit": "Report result",
      "resultValue": "99",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.5.0",
      "sampleDescription": "50 L culture broth, Day 2 — K+",
      "qcReceiptDate": "11-MAY-2025",
      "sampleId": "IPS-2388-008",
      "specificationLimit": "Report result",
      "resultValue": "3.43",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.6.0",
      "sampleDescription": "50 L culture broth, Day 2 — Ca++",
      "qcReceiptDate": "11-MAY-2025",
      "sampleId": "IPS-2388-008",
      "specificationLimit": "Report result",
      "resultValue": "0.33",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.1.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Glucose",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-009",
      "specificationLimit": "Report result",
      "resultValue": "183",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.2.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Lactate",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-009",
      "specificationLimit": "Report result",
      "resultValue": "17.4",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.3.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — pCO2",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-009",
      "specificationLimit": "Report result",
      "resultValue": "12.8",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.4.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Na+",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-009",
      "specificationLimit": "Report result",
      "resultValue": "101.7",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.5.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — K+",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-009",
      "specificationLimit": "Report result",
      "resultValue": "2.62",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "TM.11.6.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Ca++",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-009",
      "specificationLimit": "Report result",
      "resultValue": "0.31",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.4.1",
      "operationDescription": "50 L single-use STR: Pre-harvest & transfer",
      "methodId": "TM.05.1.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Viable cell concentration",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-009",
      "specificationLimit": "Report result",
      "resultValue": "3.90 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.4.1",
      "operationDescription": "50 L single-use STR: Pre-harvest & transfer",
      "methodId": "TM.05.2.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Viability",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-009",
      "specificationLimit": "Report result",
      "resultValue": "99.1",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "TM.05.1.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Viable cell concentration",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-010",
      "specificationLimit": "Report result",
      "resultValue": "9.06 x10^5",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "TM.05.2.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Viability",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-010",
      "specificationLimit": "Report result",
      "resultValue": "98.8",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "TM.11.1.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Glucose",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-010",
      "specificationLimit": "Report result",
      "resultValue": "N/A",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "TM.11.2.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Lactate",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-010",
      "specificationLimit": "Report result",
      "resultValue": "4",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "TM.11.3.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — pCO2",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-010",
      "specificationLimit": "Report result",
      "resultValue": "17.3",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "TM.11.4.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Na+",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-010",
      "specificationLimit": "Report result",
      "resultValue": "97.6",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "TM.11.5.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — K+",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-010",
      "specificationLimit": "Report result",
      "resultValue": "3.41",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "TM.11.6.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Ca++",
      "qcReceiptDate": "12-MAY-2025",
      "sampleId": "IPS-2388-010",
      "specificationLimit": "Report result",
      "resultValue": "0.31",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "TM.05.1.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Viable cell concentration",
      "qcReceiptDate": "13-MAY-2025",
      "sampleId": "IPS-2388-011",
      "specificationLimit": "Report result",
      "resultValue": "1.86 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "TM.11.1.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Glucose",
      "qcReceiptDate": "13-MAY-2025",
      "sampleId": "IPS-2388-011",
      "specificationLimit": "Report result",
      "resultValue": "312",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "TM.11.2.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Lactate",
      "qcReceiptDate": "13-MAY-2025",
      "sampleId": "IPS-2388-011",
      "specificationLimit": "Report result",
      "resultValue": "10.5",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "TM.11.3.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — pCO2",
      "qcReceiptDate": "13-MAY-2025",
      "sampleId": "IPS-2388-011",
      "specificationLimit": "Report result",
      "resultValue": "25.9",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "TM.11.4.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Na+",
      "qcReceiptDate": "13-MAY-2025",
      "sampleId": "IPS-2388-011",
      "specificationLimit": "Report result",
      "resultValue": "99.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "TM.11.5.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — K+",
      "qcReceiptDate": "13-MAY-2025",
      "sampleId": "IPS-2388-011",
      "specificationLimit": "Report result",
      "resultValue": "3.1",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "TM.11.6.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Ca++",
      "qcReceiptDate": "13-MAY-2025",
      "sampleId": "IPS-2388-011",
      "specificationLimit": "Report result",
      "resultValue": "0.32",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "TM.05.2.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Viability",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-016",
      "specificationLimit": "Report result",
      "resultValue": "89.8",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.05.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Viable cell concentration",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "Report result",
      "resultValue": "3.85 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.05.2.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Viability",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "Report result",
      "resultValue": "97.8",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.10.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Offline pH",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "6.90 - 7.30",
      "resultValue": "7.16",
      "uom": "pH",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Glucose",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "Report result",
      "resultValue": "N/A",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.2.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Lactate",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "Report result",
      "resultValue": "9.9",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.3.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — pCO2",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "Report result",
      "resultValue": "36.9",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.4.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Na+",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "Report result",
      "resultValue": "101.7",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.5.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — K+",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "Report result",
      "resultValue": "3.08",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.6.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Ca++",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-012",
      "specificationLimit": "Report result",
      "resultValue": "0.31",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.05.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Viable cell concentration",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "Report result",
      "resultValue": "3.73 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.05.2.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Viability",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "Report result",
      "resultValue": "97.8",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.10.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Offline pH",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "6.90 - 7.30",
      "resultValue": "7.12",
      "uom": "pH",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Glucose",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "Report result",
      "resultValue": "205",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.2.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Lactate",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "Report result",
      "resultValue": "11.6",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.3.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — pCO2",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "Report result",
      "resultValue": "29.2",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.4.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Na+",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "Report result",
      "resultValue": "90.7",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.5.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — K+",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "Report result",
      "resultValue": "2.55",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "TM.11.6.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Ca++",
      "qcReceiptDate": "14-MAY-2025",
      "sampleId": "IPS-2388-013",
      "specificationLimit": "Report result",
      "resultValue": "0.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.5.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Post-transfection incubation (PICS)",
      "methodId": "TM.10.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Offline pH",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-015",
      "specificationLimit": "6.90 - 7.30",
      "resultValue": "7.14",
      "uom": "pH",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.05.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Viable cell concentration",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-014",
      "specificationLimit": "Report result",
      "resultValue": "4.60 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.05.2.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Viability",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-014",
      "specificationLimit": "Report result",
      "resultValue": "96.1",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Glucose",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-014",
      "specificationLimit": "Report result",
      "resultValue": "129",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.2.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Lactate",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-014",
      "specificationLimit": "Report result",
      "resultValue": "13.8",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.3.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — pCO2",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-014",
      "specificationLimit": "Report result",
      "resultValue": "23",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.4.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Na+",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-014",
      "specificationLimit": "Report result",
      "resultValue": "90.2",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.5.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — K+",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-014",
      "specificationLimit": "Report result",
      "resultValue": "2.27",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.6.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Ca++",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-014",
      "specificationLimit": "Report result",
      "resultValue": "0.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.05.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Viable cell concentration",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-015",
      "specificationLimit": "Report result",
      "resultValue": "4.52 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Glucose",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-015",
      "specificationLimit": "Report result",
      "resultValue": "165",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.2.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Lactate",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-015",
      "specificationLimit": "Report result",
      "resultValue": "11.8",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.3.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — pCO2",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-015",
      "specificationLimit": "Report result",
      "resultValue": "34.6",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.4.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Na+",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-015",
      "specificationLimit": "Report result",
      "resultValue": "97.8",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.5.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — K+",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-015",
      "specificationLimit": "Report result",
      "resultValue": "2.44",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "TM.11.6.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Ca++",
      "qcReceiptDate": "15-MAY-2025",
      "sampleId": "IPS-2388-015",
      "specificationLimit": "Report result",
      "resultValue": "0.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "TM.05.1.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Viable cell concentration",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-016",
      "specificationLimit": "Report result",
      "resultValue": "4.91 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "TM.11.1.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Glucose",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-016",
      "specificationLimit": "Report result",
      "resultValue": "314",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "TM.11.2.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Lactate",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-016",
      "specificationLimit": "Report result",
      "resultValue": "5.6",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "TM.11.3.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — pCO2",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-016",
      "specificationLimit": "Report result",
      "resultValue": "41.2",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "TM.11.4.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Na+",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-016",
      "specificationLimit": "Report result",
      "resultValue": "103.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "TM.11.5.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — K+",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-016",
      "specificationLimit": "Report result",
      "resultValue": "3.48",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "TM.11.6.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Ca++",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-016",
      "specificationLimit": "Report result",
      "resultValue": "0.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "TM.10.1.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Offline pH",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-017",
      "specificationLimit": "6.90 - 7.30",
      "resultValue": "7.18",
      "uom": "pH",
      "result": "Pass"
    },
    {
      "procedureNumber": "4.3.1",
      "operationDescription": "Clarification / depth-filtration skid: Bioburden-reduction filtration",
      "methodId": "TM.20.1.0",
      "sampleDescription": "0.2 µm sterilising filter — Filter integrity",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-018",
      "specificationLimit": "Pass",
      "resultValue": "Pass",
      "uom": "",
      "result": "Pass"
    },
    {
      "procedureNumber": "4.3.1",
      "operationDescription": "Clarification / depth-filtration skid: Bioburden-reduction filtration",
      "methodId": "TM.30.5.2",
      "sampleDescription": "Clarified harvest — Appearance",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-018",
      "specificationLimit": "No particulates",
      "resultValue": "No particulates observed",
      "uom": "",
      "result": "Pass"
    },
    {
      "procedureNumber": "5.2.1",
      "operationDescription": "CEX chromatography skid: Load & collect flow-through",
      "methodId": "TM.30.5.2",
      "sampleDescription": "CIEX flow-through (Sartobind S) — Appearance",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-019",
      "specificationLimit": "No particulates",
      "resultValue": "No particulates observed",
      "uom": "",
      "result": "Pass"
    },
    {
      "procedureNumber": "6.4.2",
      "operationDescription": "AEX chromatography skid: Elution",
      "methodId": "TM.30.5.2",
      "sampleDescription": "AIEX eluate (Sartobind Q) — Appearance",
      "qcReceiptDate": "16-MAY-2025",
      "sampleId": "IPS-2388-020",
      "specificationLimit": "No particulates",
      "resultValue": "No particulates observed",
      "uom": "",
      "result": "Pass"
    },
    {
      "procedureNumber": "7.4.1",
      "operationDescription": "HFF / TFF skid: Diafiltration (DF)",
      "methodId": "TM.40.1.0",
      "sampleDescription": "HFF diafiltration retentate — Target diavolume wash met",
      "qcReceiptDate": "17-MAY-2025",
      "sampleId": "IPS-2388-022",
      "specificationLimit": "Yes",
      "resultValue": "Yes",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "7.4.2",
      "operationDescription": "HFF / TFF skid: Diafiltration (DF)",
      "methodId": "TM.40.1.0",
      "sampleDescription": "HFF final retentate (UDFD pool) — Target VC met",
      "qcReceiptDate": "17-MAY-2025",
      "sampleId": "IPS-2388-021",
      "specificationLimit": "Yes",
      "resultValue": "Yes",
      "uom": "%",
      "result": "Pass"
    }
  ],
  "2785-OXB-B-1": [
    {
      "procedureNumber": "1.1.4",
      "operationDescription": "Shaker flasks / CO2 incubators: Cell Thaw",
      "methodId": "T.05.1.0",
      "sampleDescription": "Thawed cell vial (WCB) — Viable cell concentration",
      "qcReceiptDate": "26-SEP-2025",
      "sampleId": "IPS-2785-001",
      "specificationLimit": "Report result",
      "resultValue": "2.51 x10^5",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.1.4",
      "operationDescription": "Shaker flasks / CO2 incubators: Cell Thaw",
      "methodId": "T.05.2.0",
      "sampleDescription": "Thawed cell vial (WCB) — Viability",
      "qcReceiptDate": "26-SEP-2025",
      "sampleId": "IPS-2785-001",
      "specificationLimit": ">= 85%",
      "resultValue": "97.4",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.2.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP0",
      "methodId": "T.05.1.0",
      "sampleDescription": "Shake-flask CSP0 harvest — Viable cell concentration",
      "qcReceiptDate": "29-SEP-2025",
      "sampleId": "IPS-2785-002",
      "specificationLimit": "Report result",
      "resultValue": "1.44 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.2.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP0",
      "methodId": "T.05.2.0",
      "sampleDescription": "Shake-flask CSP0 harvest — Viability",
      "qcReceiptDate": "29-SEP-2025",
      "sampleId": "IPS-2785-002",
      "specificationLimit": "Report result",
      "resultValue": "93.3",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.3.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP1",
      "methodId": "T.05.1.0",
      "sampleDescription": "Shake-flask CSP1 harvest — Viable cell concentration",
      "qcReceiptDate": "03-OCT-2025",
      "sampleId": "IPS-2785-003",
      "specificationLimit": "Report result",
      "resultValue": "2.65 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.3.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP1",
      "methodId": "T.05.2.0",
      "sampleDescription": "Shake-flask CSP1 harvest — Viability",
      "qcReceiptDate": "03-OCT-2025",
      "sampleId": "IPS-2785-003",
      "specificationLimit": "Report result",
      "resultValue": "95.9",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.4.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP2",
      "methodId": "T.05.1.0",
      "sampleDescription": "Shake-flask CSP2 harvest — Viable cell concentration",
      "qcReceiptDate": "07-OCT-2025",
      "sampleId": "IPS-2785-004",
      "specificationLimit": "Report result",
      "resultValue": "3.86 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.4.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP2",
      "methodId": "T.05.2.0",
      "sampleDescription": "Shake-flask CSP2 harvest — Viability",
      "qcReceiptDate": "07-OCT-2025",
      "sampleId": "IPS-2785-004",
      "specificationLimit": "Report result",
      "resultValue": "94.1",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.5.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP3",
      "methodId": "T.05.1.0",
      "sampleDescription": "Shake-flask CSP3 harvest — Viable cell concentration",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-005",
      "specificationLimit": "Report result",
      "resultValue": "2.83 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.5.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage CSP3",
      "methodId": "T.05.2.0",
      "sampleDescription": "Shake-flask CSP3 harvest — Viability",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-005",
      "specificationLimit": "Report result",
      "resultValue": "96.8",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.6.1",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage 4 (P4) — prepare N-1 inoculum",
      "methodId": "T.05.1.0",
      "sampleDescription": "P4 inoculum (N-1 seed) — Viable cell concentration",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-023",
      "specificationLimit": "Report result",
      "resultValue": "310000",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "1.6.2",
      "operationDescription": "Shaker flasks / CO2 incubators: Passage 4 (P4) — prepare N-1 inoculum",
      "methodId": "T.05.2.0",
      "sampleDescription": "P4 inoculum (N-1 seed) — Viability",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-023",
      "specificationLimit": ">= 85%",
      "resultValue": "98.7",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.2.2",
      "operationDescription": "50 L single-use STR: Inoculation (Day 0)",
      "methodId": "T.05.1.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Viable cell concentration",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-006",
      "specificationLimit": "Report result",
      "resultValue": "3.10 x10^5",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.2.2",
      "operationDescription": "50 L single-use STR: Inoculation (Day 0)",
      "methodId": "T.05.2.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Viability",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-006",
      "specificationLimit": "Report result",
      "resultValue": "98.7",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.2",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.05.1.0",
      "sampleDescription": "50 L culture broth, Day 1 — Viable cell concentration",
      "qcReceiptDate": "11-OCT-2025",
      "sampleId": "IPS-2785-007",
      "specificationLimit": "Report result",
      "resultValue": "6.44 x10^5",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.2",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.05.2.0",
      "sampleDescription": "50 L culture broth, Day 1 — Viability",
      "qcReceiptDate": "11-OCT-2025",
      "sampleId": "IPS-2785-007",
      "specificationLimit": "Report result",
      "resultValue": "98.5",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.3",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.05.1.0",
      "sampleDescription": "50 L culture broth, Day 2 — Viable cell concentration",
      "qcReceiptDate": "12-OCT-2025",
      "sampleId": "IPS-2785-008",
      "specificationLimit": "Report result",
      "resultValue": "1.53 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.3",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.05.2.0",
      "sampleDescription": "50 L culture broth, Day 2 — Viability",
      "qcReceiptDate": "12-OCT-2025",
      "sampleId": "IPS-2785-008",
      "specificationLimit": "Report result",
      "resultValue": "99",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.1.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Glucose",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-006",
      "specificationLimit": "Report result",
      "resultValue": "stability",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.2.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Lactate",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-006",
      "specificationLimit": "Report result",
      "resultValue": "1.4",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.3.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — pCO2",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-006",
      "specificationLimit": "Report result",
      "resultValue": "83.1",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.4.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Na+",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-006",
      "specificationLimit": "Report result",
      "resultValue": "101.1",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.5.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — K+",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-006",
      "specificationLimit": "Report result",
      "resultValue": "3.5",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.6.0",
      "sampleDescription": "50 L culture broth, Day 0 (post-inoculation) — Ca++",
      "qcReceiptDate": "10-OCT-2025",
      "sampleId": "IPS-2785-006",
      "specificationLimit": "Report result",
      "resultValue": "0.31",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.1.0",
      "sampleDescription": "50 L culture broth, Day 1 — Glucose",
      "qcReceiptDate": "11-OCT-2025",
      "sampleId": "IPS-2785-007",
      "specificationLimit": "Report result",
      "resultValue": "stability",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.2.0",
      "sampleDescription": "50 L culture broth, Day 1 — Lactate",
      "qcReceiptDate": "11-OCT-2025",
      "sampleId": "IPS-2785-007",
      "specificationLimit": "Report result",
      "resultValue": "3.8",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.3.0",
      "sampleDescription": "50 L culture broth, Day 1 — pCO2",
      "qcReceiptDate": "11-OCT-2025",
      "sampleId": "IPS-2785-007",
      "specificationLimit": "Report result",
      "resultValue": "74.2",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.4.0",
      "sampleDescription": "50 L culture broth, Day 1 — Na+",
      "qcReceiptDate": "11-OCT-2025",
      "sampleId": "IPS-2785-007",
      "specificationLimit": "Report result",
      "resultValue": "100.5",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.5.0",
      "sampleDescription": "50 L culture broth, Day 1 — K+",
      "qcReceiptDate": "11-OCT-2025",
      "sampleId": "IPS-2785-007",
      "specificationLimit": "Report result",
      "resultValue": "3.42",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.6.0",
      "sampleDescription": "50 L culture broth, Day 1 — Ca++",
      "qcReceiptDate": "11-OCT-2025",
      "sampleId": "IPS-2785-007",
      "specificationLimit": "Report result",
      "resultValue": "0.31",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.1.0",
      "sampleDescription": "50 L culture broth, Day 2 — Glucose",
      "qcReceiptDate": "12-OCT-2025",
      "sampleId": "IPS-2785-008",
      "specificationLimit": "Report result",
      "resultValue": "313",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.2.0",
      "sampleDescription": "50 L culture broth, Day 2 — Lactate",
      "qcReceiptDate": "12-OCT-2025",
      "sampleId": "IPS-2785-008",
      "specificationLimit": "Report result",
      "resultValue": "10.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.3.0",
      "sampleDescription": "50 L culture broth, Day 2 — pCO2",
      "qcReceiptDate": "12-OCT-2025",
      "sampleId": "IPS-2785-008",
      "specificationLimit": "Report result",
      "resultValue": "29.8",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.4.0",
      "sampleDescription": "50 L culture broth, Day 2 — Na+",
      "qcReceiptDate": "12-OCT-2025",
      "sampleId": "IPS-2785-008",
      "specificationLimit": "Report result",
      "resultValue": "101.6",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.5.0",
      "sampleDescription": "50 L culture broth, Day 2 — K+",
      "qcReceiptDate": "12-OCT-2025",
      "sampleId": "IPS-2785-008",
      "specificationLimit": "Report result",
      "resultValue": "3.07",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.6.0",
      "sampleDescription": "50 L culture broth, Day 2 — Ca++",
      "qcReceiptDate": "12-OCT-2025",
      "sampleId": "IPS-2785-008",
      "specificationLimit": "Report result",
      "resultValue": "0.33",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.1.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Glucose",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-009",
      "specificationLimit": "Report result",
      "resultValue": "184",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.2.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Lactate",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-009",
      "specificationLimit": "Report result",
      "resultValue": "17.2",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.3.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — pCO2",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-009",
      "specificationLimit": "Report result",
      "resultValue": "17.9",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.4.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Na+",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-009",
      "specificationLimit": "Report result",
      "resultValue": "103.9",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.5.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — K+",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-009",
      "specificationLimit": "Report result",
      "resultValue": "2.72",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.3.4",
      "operationDescription": "50 L single-use STR: Growth & culture control",
      "methodId": "T.11.6.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Ca++",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-009",
      "specificationLimit": "Report result",
      "resultValue": "0.32",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "2.4.1",
      "operationDescription": "50 L single-use STR: Pre-harvest & transfer",
      "methodId": "T.05.1.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Viable cell concentration",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-009",
      "specificationLimit": "Report result",
      "resultValue": "3.62 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "2.4.1",
      "operationDescription": "50 L single-use STR: Pre-harvest & transfer",
      "methodId": "T.05.2.0",
      "sampleDescription": "50 L culture broth, Day 3 (pre-harvest) — Viability",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-009",
      "specificationLimit": "Report result",
      "resultValue": "96.3",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "T.05.1.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Viable cell concentration",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-010",
      "specificationLimit": "Report result",
      "resultValue": "9.23 x10^5",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "T.05.2.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Viability",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-010",
      "specificationLimit": "Report result",
      "resultValue": "98.5",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "T.11.1.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Glucose",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-010",
      "specificationLimit": "Report result",
      "resultValue": "394",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "T.11.2.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Lactate",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-010",
      "specificationLimit": "Report result",
      "resultValue": "4.4",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "T.11.3.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — pCO2",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-010",
      "specificationLimit": "Report result",
      "resultValue": "18.8",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "T.11.4.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Na+",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-010",
      "specificationLimit": "Report result",
      "resultValue": "99.6",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "T.11.5.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — K+",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-010",
      "specificationLimit": "Report result",
      "resultValue": "3.35",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.2.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Inoculation (P5, Day 0)",
      "methodId": "T.11.6.0",
      "sampleDescription": "200 L culture broth, Day 0 (post-inoculation) — Ca++",
      "qcReceiptDate": "13-OCT-2025",
      "sampleId": "IPS-2785-010",
      "specificationLimit": "Report result",
      "resultValue": "0.32",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "T.05.1.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Viable cell concentration",
      "qcReceiptDate": "14-OCT-2025",
      "sampleId": "IPS-2785-011",
      "specificationLimit": "Report result",
      "resultValue": "1.88 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "T.11.1.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Glucose",
      "qcReceiptDate": "14-OCT-2025",
      "sampleId": "IPS-2785-011",
      "specificationLimit": "Report result",
      "resultValue": "294",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "T.11.2.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Lactate",
      "qcReceiptDate": "14-OCT-2025",
      "sampleId": "IPS-2785-011",
      "specificationLimit": "Report result",
      "resultValue": "11.4",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "T.11.3.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — pCO2",
      "qcReceiptDate": "14-OCT-2025",
      "sampleId": "IPS-2785-011",
      "specificationLimit": "Report result",
      "resultValue": "39.2",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "T.11.4.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Na+",
      "qcReceiptDate": "14-OCT-2025",
      "sampleId": "IPS-2785-011",
      "specificationLimit": "Report result",
      "resultValue": "102.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "T.11.5.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — K+",
      "qcReceiptDate": "14-OCT-2025",
      "sampleId": "IPS-2785-011",
      "specificationLimit": "Report result",
      "resultValue": "2.91",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "T.11.6.0",
      "sampleDescription": "200 L culture broth, Day 1 (pre-Perfusion A) — Ca++",
      "qcReceiptDate": "14-OCT-2025",
      "sampleId": "IPS-2785-011",
      "specificationLimit": "Report result",
      "resultValue": "0.33",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.3.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Perfusion A",
      "methodId": "T.05.2.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Viability",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-016",
      "specificationLimit": "Report result",
      "resultValue": "88.9",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.05.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Viable cell concentration",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "Report result",
      "resultValue": "4.03 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.05.2.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Viability",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "Report result",
      "resultValue": "97.3",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.10.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Offline pH",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "6.90 - 7.30",
      "resultValue": "7.2",
      "uom": "pH",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Glucose",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "Report result",
      "resultValue": "328",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.2.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Lactate",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "Report result",
      "resultValue": "10",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.3.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — pCO2",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "Report result",
      "resultValue": "56.7",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.4.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Na+",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "Report result",
      "resultValue": "108.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.5.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — K+",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "Report result",
      "resultValue": "3.1",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.6.0",
      "sampleDescription": "200 L culture broth, Day 2 (pre-transfection) — Ca++",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-012",
      "specificationLimit": "Report result",
      "resultValue": "0.32",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.05.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Viable cell concentration",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "Report result",
      "resultValue": "3.48 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.05.2.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Viability",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "Report result",
      "resultValue": "97.6",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.10.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Offline pH",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "6.90 - 7.30",
      "resultValue": "7.11",
      "uom": "pH",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.1.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Glucose",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "Report result",
      "resultValue": "193",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.2.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Lactate",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "Report result",
      "resultValue": "14",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.3.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — pCO2",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "Report result",
      "resultValue": "19",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.4.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Na+",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "Report result",
      "resultValue": "96.4",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.5.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — K+",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "Report result",
      "resultValue": "2.41",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.4.4",
      "operationDescription": "200 L STR + KTF perfusion skid: Transfection",
      "methodId": "T.11.6.0",
      "sampleDescription": "200 L culture broth, Day 2 (post-transfection) — Ca++",
      "qcReceiptDate": "15-OCT-2025",
      "sampleId": "IPS-2785-013",
      "specificationLimit": "Report result",
      "resultValue": "0.3",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.5.2",
      "operationDescription": "200 L STR + KTF perfusion skid: Post-transfection incubation (PICS)",
      "methodId": "T.10.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Offline pH",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-015",
      "specificationLimit": "6.90 - 7.30",
      "resultValue": "7.09",
      "uom": "pH",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.05.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Viable cell concentration",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-014",
      "specificationLimit": "Report result",
      "resultValue": "3.95 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.05.2.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Viability",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-014",
      "specificationLimit": "Report result",
      "resultValue": "96.1",
      "uom": "%",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Glucose",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-014",
      "specificationLimit": "Report result",
      "resultValue": "92",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.2.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Lactate",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-014",
      "specificationLimit": "Report result",
      "resultValue": "15.8",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.3.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — pCO2",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-014",
      "specificationLimit": "Report result",
      "resultValue": "slope",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.4.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Na+",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-014",
      "specificationLimit": "Report result",
      "resultValue": "98",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.5.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — K+",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-014",
      "specificationLimit": "Report result",
      "resultValue": "2.08",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.6.0",
      "sampleDescription": "200 L culture broth, Day 3 (pre-induction) — Ca++",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-014",
      "specificationLimit": "Report result",
      "resultValue": "0.29",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.05.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Viable cell concentration",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-015",
      "specificationLimit": "Report result",
      "resultValue": "4.31 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.1.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Glucose",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-015",
      "specificationLimit": "Report result",
      "resultValue": "135",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.2.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Lactate",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-015",
      "specificationLimit": "Report result",
      "resultValue": "13.5",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.3.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — pCO2",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-015",
      "specificationLimit": "Report result",
      "resultValue": "38.3",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.4.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Na+",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-015",
      "specificationLimit": "Report result",
      "resultValue": "105.2",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.5.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — K+",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-015",
      "specificationLimit": "Report result",
      "resultValue": "2.12",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.7.3",
      "operationDescription": "200 L STR + KTF perfusion skid: Induction",
      "methodId": "T.11.6.0",
      "sampleDescription": "200 L culture broth, Day 3 (post-induction) — Ca++",
      "qcReceiptDate": "16-OCT-2025",
      "sampleId": "IPS-2785-015",
      "specificationLimit": "Report result",
      "resultValue": "0.27",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "T.05.1.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Viable cell concentration",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-016",
      "specificationLimit": "Report result",
      "resultValue": "6.46 x10^6",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "T.11.1.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Glucose",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-016",
      "specificationLimit": "Report result",
      "resultValue": "330",
      "uom": "mg/dL",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "T.11.2.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Lactate",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-016",
      "specificationLimit": "Report result",
      "resultValue": "6.2",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "T.11.3.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — pCO2",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-016",
      "specificationLimit": "Report result",
      "resultValue": "46.8",
      "uom": "mmHg",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "T.11.4.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Na+",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-016",
      "specificationLimit": "Report result",
      "resultValue": "107.4",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "T.11.5.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — K+",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-016",
      "specificationLimit": "Report result",
      "resultValue": "3.36",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "T.11.6.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Ca++",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-016",
      "specificationLimit": "Report result",
      "resultValue": "0.29",
      "uom": "mmol/L",
      "result": "Report result"
    },
    {
      "procedureNumber": "3.9.1",
      "operationDescription": "200 L STR + KTF perfusion skid: Pre-harvest (PHPB, Day 4)",
      "methodId": "T.10.1.0",
      "sampleDescription": "200 L culture broth, Day 4 (pre-harvest) — Offline pH",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-017",
      "specificationLimit": "6.90 - 7.30",
      "resultValue": "7.12",
      "uom": "pH",
      "result": "Pass"
    },
    {
      "procedureNumber": "4.3.1",
      "operationDescription": "Clarification / depth-filtration skid: Bioburden-reduction filtration",
      "methodId": "T.20.1.0",
      "sampleDescription": "0.2 µm sterilising filter — Filter integrity",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-018",
      "specificationLimit": "Pass",
      "resultValue": "Pass",
      "uom": "",
      "result": "Pass"
    },
    {
      "procedureNumber": "4.3.1",
      "operationDescription": "Clarification / depth-filtration skid: Bioburden-reduction filtration",
      "methodId": "T.30.5.2",
      "sampleDescription": "Clarified harvest — Appearance",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-018",
      "specificationLimit": "No particulates",
      "resultValue": "No particulates observed",
      "uom": "",
      "result": "Pass"
    },
    {
      "procedureNumber": "5.2.1",
      "operationDescription": "CEX chromatography skid: Load & collect flow-through",
      "methodId": "T.30.5.2",
      "sampleDescription": "CIEX flow-through (Sartobind S) — Appearance",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-019",
      "specificationLimit": "No particulates",
      "resultValue": "No particulates observed",
      "uom": "",
      "result": "Pass"
    },
    {
      "procedureNumber": "6.4.2",
      "operationDescription": "AEX chromatography skid: Elution",
      "methodId": "T.30.5.2",
      "sampleDescription": "AIEX eluate (Sartobind Q) — Appearance",
      "qcReceiptDate": "17-OCT-2025",
      "sampleId": "IPS-2785-020",
      "specificationLimit": "No particulates",
      "resultValue": "No particulates observed",
      "uom": "",
      "result": "Pass"
    },
    {
      "procedureNumber": "7.4.1",
      "operationDescription": "HFF / TFF skid: Diafiltration (DF)",
      "methodId": "T.40.1.0",
      "sampleDescription": "HFF diafiltration retentate — Target diavolume wash met",
      "qcReceiptDate": "18-OCT-2025",
      "sampleId": "IPS-2785-022",
      "specificationLimit": "Yes",
      "resultValue": "Yes",
      "uom": "cells/mL",
      "result": "Pass"
    },
    {
      "procedureNumber": "7.4.2",
      "operationDescription": "HFF / TFF skid: Diafiltration (DF)",
      "methodId": "T.40.1.0",
      "sampleDescription": "HFF final retentate (UDFD pool) — Target VC met",
      "qcReceiptDate": "18-OCT-2025",
      "sampleId": "IPS-2785-021",
      "specificationLimit": "Yes",
      "resultValue": "Yes",
      "uom": "%",
      "result": "Pass"
    }
  ]
};

export const RELEASE_DATA = {
  "TZB2401-DS": [
    {
      "methodId": "T.50.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "8-Feb-2026",
      "sampleId": "DS-IDP-001",
      "specificationLimit": "Conforms to reference (peptide map LC-MS)",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved",
      "analyticalReportNumber": "AR-IDP-2026-001"
    },
    {
      "methodId": "T.30.5.2",
      "sampleDescription": "Thawed DS solution",
      "qcReceiptDate": "8-Feb-2026",
      "sampleId": "DS-APP-001",
      "specificationLimit": "Clear to slightly opalescent; essentially free of visible particles",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved",
      "analyticalReportNumber": "AR-APP-2026-005"
    },
    {
      "methodId": "T.16.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "9-Feb-2026",
      "sampleId": "DS-CONC-001",
      "specificationLimit": "19.0 - 21.0 g/L",
      "resultValue": "20.1",
      "uom": "g/L",
      "result": "Approved",
      "analyticalReportNumber": "AR-CONC-2026-007"
    },
    {
      "methodId": "T.20.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "9-Feb-2026",
      "sampleId": "DS-AGG-001",
      "specificationLimit": "HMW aggregates <= 1.5% (SEC-HPLC)",
      "resultValue": "0.9",
      "uom": "%",
      "result": "Approved",
      "analyticalReportNumber": "AR-AGG-2026-010"
    },
    {
      "methodId": "T.51.2.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "9-Feb-2026",
      "sampleId": "DS-CER-001",
      "specificationLimit": "Reduced HC+LC purity >= 97% (CE-SDS)",
      "resultValue": "99.2",
      "uom": "%",
      "result": "Approved",
      "analyticalReportNumber": "AR-CER-2026-013"
    },
    {
      "methodId": "T.21.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "10-Feb-2026",
      "sampleId": "DS-ICM-001",
      "specificationLimit": "Main peak 55-75% (iCIEF)",
      "resultValue": "66",
      "uom": "%",
      "result": "Approved",
      "analyticalReportNumber": "AR-ICM-2026-014"
    },
    {
      "methodId": "T.52.2.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "10-Feb-2026",
      "sampleId": "DS-AFU-001",
      "specificationLimit": "Afucosylated glycans 2.0 - 8.0%",
      "resultValue": "4.7",
      "uom": "%",
      "result": "Approved",
      "analyticalReportNumber": "AR-AFU-2026-018"
    },
    {
      "methodId": "T.17.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "11-Feb-2026",
      "sampleId": "DS-HCP-001",
      "specificationLimit": "<= 100 ppm",
      "resultValue": "14",
      "uom": "ppm",
      "result": "Approved",
      "analyticalReportNumber": "AR-HCP-2026-019"
    },
    {
      "methodId": "T.17.2.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "11-Feb-2026",
      "sampleId": "DS-HCD-001",
      "specificationLimit": "<= 100 pg/mg",
      "resultValue": "16",
      "uom": "pg/mg",
      "result": "Approved",
      "analyticalReportNumber": "AR-HCD-2026-020"
    },
    {
      "methodId": "T.17.3.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "11-Feb-2026",
      "sampleId": "DS-PAL-001",
      "specificationLimit": "<= 20 ppm",
      "resultValue": "4.6",
      "uom": "ppm",
      "result": "Approved",
      "analyticalReportNumber": "AR-PAL-2026-021"
    },
    {
      "methodId": "T.26.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "11-Feb-2026",
      "sampleId": "DS-TRE-001",
      "specificationLimit": "80 - 88 mg/mL trehalose",
      "resultValue": "84.2",
      "uom": "mg/mL",
      "result": "Approved",
      "analyticalReportNumber": "AR-TRE-2026-022"
    },
    {
      "methodId": "T.25.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "11-Feb-2026",
      "sampleId": "DS-PS20-001",
      "specificationLimit": "0.36 - 0.44 mg/mL PS20",
      "resultValue": "0.4",
      "uom": "mg/mL",
      "result": "Approved",
      "analyticalReportNumber": "AR-PS20-2026-023"
    },
    {
      "methodId": "T.10.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "12-Feb-2026",
      "sampleId": "DS-PH-001",
      "specificationLimit": "5.8 - 6.2",
      "resultValue": "6.04",
      "uom": "pH",
      "result": "Approved",
      "analyticalReportNumber": "AR-PH-2026-024"
    },
    {
      "methodId": "T.23.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "12-Feb-2026",
      "sampleId": "DS-OSM-001",
      "specificationLimit": "290 - 340 mOsm/kg",
      "resultValue": "316",
      "uom": "mOsm/kg",
      "result": "Approved",
      "analyticalReportNumber": "AR-OSM-2026-025"
    },
    {
      "methodId": "T.08.2.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "13-Feb-2026",
      "sampleId": "DS-BIO-001",
      "specificationLimit": "<= 1 CFU/10 mL (bioburden)",
      "resultValue": "0",
      "uom": "CFU/10mL",
      "result": "Approved",
      "analyticalReportNumber": "AR-BIO-2026-030"
    },
    {
      "methodId": "T.22.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "13-Feb-2026",
      "sampleId": "DS-END-001",
      "specificationLimit": "<= 0.5 EU/mg",
      "resultValue": "0.08",
      "uom": "EU/mg",
      "result": "Approved",
      "analyticalReportNumber": "AR-END-2026-031"
    },
    {
      "methodId": "T.40.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "14-Feb-2026",
      "sampleId": "DS-POT-001",
      "specificationLimit": "80 - 125% of reference (HER2 binding)",
      "resultValue": "102.4",
      "uom": "%",
      "result": "Approved",
      "analyticalReportNumber": "AR-POT-2026-032"
    },
    {
      "methodId": "T.41.1.0",
      "sampleDescription": "Thawed DS bag composite",
      "qcReceiptDate": "14-Feb-2026",
      "sampleId": "DS-ADCC-001",
      "specificationLimit": "70 - 130% of reference (ADCC bioassay)",
      "resultValue": "108",
      "uom": "%",
      "result": "Approved",
      "analyticalReportNumber": "AR-ADCC-2026-033"
    }
  ],
  "2388-OXB-A-1": [
    {
      "methodId": "T.64.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "19-MAY-2025",
      "sampleId": "DS-2388-IDT-01",
      "specificationLimit": "Transgene (anti-CD19 CAR) sequence confirmed",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.65.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "19-MAY-2025",
      "sampleId": "DS-2388-IDV-01",
      "specificationLimit": "VSV-G envelope identity confirmed (qPCR)",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.30.5.2",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "19-MAY-2025",
      "sampleId": "DS-2388-APP-01",
      "specificationLimit": "Clear, colorless to slightly opalescent; free of visible particles",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.60.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-MAY-2025",
      "sampleId": "DS-2388-TIT-01",
      "specificationLimit": ">= 1.0 x10^8 TU/mL (infectious titer)",
      "resultValue": "185000000",
      "uom": "TU/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.61.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-MAY-2025",
      "sampleId": "DS-2388-P24-01",
      "specificationLimit": "Report physical titer (p24 ELISA)",
      "resultValue": "5600",
      "uom": "ng/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.66.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-MAY-2025",
      "sampleId": "DS-2388-SI-01",
      "specificationLimit": ">= 5.0 x10^3 TU/ng p24 (specific infectivity)",
      "resultValue": "33000",
      "uom": "TU/ng",
      "result": "Approved"
    },
    {
      "methodId": "T.40.2.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-MAY-2025",
      "sampleId": "DS-2388-POT-01",
      "specificationLimit": "50 - 150% of reference (transduction potency, %CAR+)",
      "resultValue": "103",
      "uom": "%",
      "result": "Approved"
    },
    {
      "methodId": "T.17.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-MAY-2025",
      "sampleId": "DS-2388-HCP-01",
      "specificationLimit": "<= 100 ng/mL (HEK293 HCP)",
      "resultValue": "22",
      "uom": "ng/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.17.2.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-MAY-2025",
      "sampleId": "DS-2388-HCD-01",
      "specificationLimit": "<= 10 ng/dose (residual host cell DNA)",
      "resultValue": "1.8",
      "uom": "ng/dose",
      "result": "Approved"
    },
    {
      "methodId": "T.17.4.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-MAY-2025",
      "sampleId": "DS-2388-PLD-01",
      "specificationLimit": "<= 10 ng/dose (residual plasmid DNA)",
      "resultValue": "2.4",
      "uom": "ng/dose",
      "result": "Approved"
    },
    {
      "methodId": "T.17.5.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-MAY-2025",
      "sampleId": "DS-2388-BEN-01",
      "specificationLimit": "<= 10 ng/mL (residual Benzonase)",
      "resultValue": "0.7",
      "uom": "ng/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.10.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-MAY-2025",
      "sampleId": "DS-2388-PH-01",
      "specificationLimit": "7.0 - 7.6",
      "resultValue": "7.28",
      "uom": "pH",
      "result": "Approved"
    },
    {
      "methodId": "T.23.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-MAY-2025",
      "sampleId": "DS-2388-OSM-01",
      "specificationLimit": "280 - 360 mOsm/kg",
      "resultValue": "318",
      "uom": "mOsm/kg",
      "result": "Approved"
    },
    {
      "methodId": "T.08.2.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-MAY-2025",
      "sampleId": "DS-2388-BIO-01",
      "specificationLimit": "No growth (bioburden)",
      "resultValue": "0",
      "uom": "CFU/10mL",
      "result": "Approved"
    },
    {
      "methodId": "T.71.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "23-MAY-2025",
      "sampleId": "DS-2388-STE-01",
      "specificationLimit": "No growth (sterility, USP <71>)",
      "resultValue": "No growth",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.07.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-MAY-2025",
      "sampleId": "DS-2388-MYC-01",
      "specificationLimit": "Negative (mycoplasma, NAT)",
      "resultValue": "Negative",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.22.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-MAY-2025",
      "sampleId": "DS-2388-END-01",
      "specificationLimit": "<= 5 EU/mL (endotoxin, LAL)",
      "resultValue": "0.3",
      "uom": "EU/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.72.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "23-MAY-2025",
      "sampleId": "DS-2388-RCL-01",
      "specificationLimit": "Not detected (Replication-Competent Lentivirus)",
      "resultValue": "Not detected",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.73.1.0",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "23-MAY-2025",
      "sampleId": "DS-2388-AAV-01",
      "specificationLimit": "No adventitious agents detected (in vitro)",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved"
    }
  ],
  "2785-OXB-B-1": [
    {
      "methodId": "T.64.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-OCT-2025",
      "sampleId": "DS-IDT-001",
      "specificationLimit": "Transgene (anti-CD19 CAR) sequence confirmed",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.65.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-OCT-2025",
      "sampleId": "DS-IDV-001",
      "specificationLimit": "VSV-G envelope identity confirmed (qPCR)",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.30.5.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "20-OCT-2025",
      "sampleId": "DS-APP-001",
      "specificationLimit": "Clear, colorless to slightly opalescent; free of visible particles",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.60.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-OCT-2025",
      "sampleId": "DS-TIT-001",
      "specificationLimit": ">= 1.0 x10^8 TU/mL (infectious titer)",
      "resultValue": "170000000",
      "uom": "TU/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.61.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-OCT-2025",
      "sampleId": "DS-P24-001",
      "specificationLimit": "Report physical titer (p24 ELISA)",
      "resultValue": "5400",
      "uom": "ng/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.66.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-OCT-2025",
      "sampleId": "DS-SI-001",
      "specificationLimit": ">= 5.0 x10^3 TU/ng p24 (specific infectivity)",
      "resultValue": "31500",
      "uom": "TU/ng",
      "result": "Approved"
    },
    {
      "methodId": "T.40.2.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "22-OCT-2025",
      "sampleId": "DS-POT-001",
      "specificationLimit": "50 - 150% of reference (transduction potency, %CAR+)",
      "resultValue": "98",
      "uom": "%",
      "result": "Approved"
    },
    {
      "methodId": "T.17.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "22-OCT-2025",
      "sampleId": "DS-HCP-001",
      "specificationLimit": "<= 100 ng/mL (HEK293 HCP)",
      "resultValue": "26",
      "uom": "ng/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.17.2.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "22-OCT-2025",
      "sampleId": "DS-HCD-001",
      "specificationLimit": "<= 10 ng/dose (residual host cell DNA)",
      "resultValue": "2.1",
      "uom": "ng/dose",
      "result": "Approved"
    },
    {
      "methodId": "T.17.4.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "22-OCT-2025",
      "sampleId": "DS-PLD-001",
      "specificationLimit": "<= 10 ng/dose (residual plasmid DNA)",
      "resultValue": "3",
      "uom": "ng/dose",
      "result": "Approved"
    },
    {
      "methodId": "T.17.5.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "22-OCT-2025",
      "sampleId": "DS-BEN-001",
      "specificationLimit": "<= 10 ng/mL (residual Benzonase)",
      "resultValue": "0.9",
      "uom": "ng/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.10.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-OCT-2025",
      "sampleId": "DS-PH-001",
      "specificationLimit": "7.0 - 7.6",
      "resultValue": "7.31",
      "uom": "pH",
      "result": "Approved"
    },
    {
      "methodId": "T.23.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-OCT-2025",
      "sampleId": "DS-OSM-001",
      "specificationLimit": "280 - 360 mOsm/kg",
      "resultValue": "322",
      "uom": "mOsm/kg",
      "result": "Approved"
    },
    {
      "methodId": "T.08.2.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-OCT-2025",
      "sampleId": "DS-BIO-001",
      "specificationLimit": "No growth (bioburden)",
      "resultValue": "0",
      "uom": "CFU/10mL",
      "result": "Approved"
    },
    {
      "methodId": "T.71.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "24-OCT-2025",
      "sampleId": "DS-STE-001",
      "specificationLimit": "No growth (sterility, USP <71>)",
      "resultValue": "No growth",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.07.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "22-OCT-2025",
      "sampleId": "DS-MYC-001",
      "specificationLimit": "Negative (mycoplasma, NAT)",
      "resultValue": "Negative",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.22.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "21-OCT-2025",
      "sampleId": "DS-END-001",
      "specificationLimit": "<= 5 EU/mL (endotoxin, LAL)",
      "resultValue": "0.4",
      "uom": "EU/mL",
      "result": "Approved"
    },
    {
      "methodId": "T.72.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "24-OCT-2025",
      "sampleId": "DS-RCL-001",
      "specificationLimit": "Not detected (Replication-Competent Lentivirus)",
      "resultValue": "Not detected",
      "uom": "NA",
      "result": "Approved"
    },
    {
      "methodId": "T.73.1.1",
      "sampleDescription": "Viral Vector DS",
      "qcReceiptDate": "24-OCT-2025",
      "sampleId": "DS-AAV-001",
      "specificationLimit": "No adventitious agents detected (in vitro)",
      "resultValue": "Conforms",
      "uom": "NA",
      "result": "Approved"
    }
  ]
};

export const EQUIPMENT_DATA = {
  "TZB2401-DS": [
    {
      "procedureNumber": "1.1.1",
      "equipmentId": "EQ-BSC-101",
      "location": "Suite-201, Building 12 (Grade B)",
      "equipmentType": "Biosafety Cabinet",
      "description": "Class II Type A2 BSC, 1.5 m, HEPA filtered (cell thaw and seed expansion)",
      "actualStartDate": "5-Jan-2026 0:00:00",
      "actualEndDate": "9-Jan-2026 0:00:00",
      "reservationId": "RES-101"
    },
    {
      "procedureNumber": "1.1.1",
      "equipmentId": "EQ-INC-102",
      "location": "Suite-201, Building 12",
      "equipmentType": "CO2 Incubator",
      "description": "Thermo Heracell VIOS 250i, 37 C / 5% CO2 (T-flasks and shake flasks)",
      "actualStartDate": "5-Jan-2026 0:00:00",
      "actualEndDate": "9-Jan-2026 0:00:00",
      "reservationId": "RES-102"
    },
    {
      "procedureNumber": "2.1.1",
      "equipmentId": "EQ-SBR-103",
      "location": "Suite-202, Building 12 (Grade C)",
      "equipmentType": "Seed Bioreactor",
      "description": "Sartorius Biostat B-DCU 200 L single-use (N-1 inoculum expansion)",
      "actualStartDate": "8-Jan-2026 0:00:00",
      "actualEndDate": "12-Jan-2026 0:00:00",
      "reservationId": "RES-103"
    },
    {
      "procedureNumber": "3.1.1",
      "equipmentId": "EQ-PBR-104",
      "location": "Suite-203, Building 12 (Grade C)",
      "equipmentType": "Production Bioreactor",
      "description": "2000 L stainless steel jacketed BR-202, fed-batch, 14-day culture",
      "actualStartDate": "10-Jan-2026 0:00:00",
      "actualEndDate": "25-Jan-2026 0:00:00",
      "reservationId": "RES-104"
    },
    {
      "procedureNumber": "3.1.1",
      "equipmentId": "EQ-TCU-105",
      "location": "Suite-203, Building 12",
      "equipmentType": "Temperature Control Unit",
      "description": "Lauda Integral XT 1850, chilled water supply for BR-202 jacket",
      "actualStartDate": "10-Jan-2026 0:00:00",
      "actualEndDate": "25-Jan-2026 0:00:00",
      "reservationId": "RES-105"
    },
    {
      "procedureNumber": "3.1.1",
      "equipmentId": "EQ-BIOA-106",
      "location": "Suite-203, Building 12",
      "equipmentType": "Bioanalyzer",
      "description": "Nova Flex2 cell counter and metabolite analyzer (glucose, lactate, gln)",
      "actualStartDate": "10-Jan-2026 0:00:00",
      "actualEndDate": "25-Jan-2026 0:00:00",
      "reservationId": "RES-106"
    },
    {
      "procedureNumber": "4.1.1",
      "equipmentId": "EQ-DC-201",
      "location": "Suite-204, Building 12 (Grade C)",
      "equipmentType": "Disc Stack Centrifuge",
      "description": "Alfa Laval Culturefuge 100 (clarification, 8000-12000 x g)",
      "actualStartDate": "24-Jan-2026 0:00:00",
      "actualEndDate": "25-Jan-2026 0:00:00",
      "reservationId": "RES-201"
    },
    {
      "procedureNumber": "4.1.1",
      "equipmentId": "EQ-DFS-202",
      "location": "Suite-204, Building 12",
      "equipmentType": "Depth Filtration Skid",
      "description": "Millistak+ POD, 6 x 1.1 m2 X0HC + 0.2 um sterile filter",
      "actualStartDate": "24-Jan-2026 0:00:00",
      "actualEndDate": "25-Jan-2026 0:00:00",
      "reservationId": "RES-202"
    },
    {
      "procedureNumber": "4.1.1",
      "equipmentId": "EQ-HT-203",
      "location": "Suite-204, Building 12",
      "equipmentType": "Hold Tank",
      "description": "500 L stainless steel jacketed hold tank, 2-8 C (clarified harvest)",
      "actualStartDate": "25-Jan-2026 0:00:00",
      "actualEndDate": "27-Jan-2026 0:00:00",
      "reservationId": "RES-203"
    },
    {
      "procedureNumber": "5.1.1",
      "equipmentId": "EQ-CHR-301",
      "location": "Suite-301, Building 12 (Grade C)",
      "equipmentType": "Chromatography Skid",
      "description": "Cytiva AKTA ready XL, 40 L MabSelect SuRe Protein A column (Capture)",
      "actualStartDate": "26-Jan-2026 0:00:00",
      "actualEndDate": "27-Jan-2026 0:00:00",
      "reservationId": "RES-301"
    },
    {
      "procedureNumber": "6.1.1",
      "equipmentId": "EQ-VIT-302",
      "location": "Suite-301, Building 12",
      "equipmentType": "Viral Inactivation Tank",
      "description": "800 L stainless steel jacketed tank with pH control (low pH hold)",
      "actualStartDate": "27-Jan-2026 0:00:00",
      "actualEndDate": "27-Jan-2026 0:00:00",
      "reservationId": "RES-302"
    },
    {
      "procedureNumber": "7.1.1",
      "equipmentId": "EQ-CHR-303",
      "location": "Suite-302, Building 12 (Grade C)",
      "equipmentType": "Chromatography Skid",
      "description": "Cytiva AKTA process 100, 20 L Capto SP ImpRes CEX + 14 L Capto Q AEX",
      "actualStartDate": "28-Jan-2026 0:00:00",
      "actualEndDate": "29-Jan-2026 0:00:00",
      "reservationId": "RES-303"
    },
    {
      "procedureNumber": "8.1.1",
      "equipmentId": "EQ-VFS-304",
      "location": "Suite-302, Building 12",
      "equipmentType": "Viral Filtration Skid",
      "description": "Asahi Kasei Planova 20N filter skid, 4 x 1.0 m2 filters",
      "actualStartDate": "29-Jan-2026 0:00:00",
      "actualEndDate": "30-Jan-2026 0:00:00",
      "reservationId": "RES-304"
    },
    {
      "procedureNumber": "9.1.1",
      "equipmentId": "EQ-UFD-305",
      "location": "Suite-303, Building 12 (Grade C)",
      "equipmentType": "UF/DF Skid",
      "description": "Sartorius Sartoflow Smart, Pellicon 3 30 kDa cassettes (6 x 1.14 m2)",
      "actualStartDate": "30-Jan-2026 0:00:00",
      "actualEndDate": "31-Jan-2026 0:00:00",
      "reservationId": "RES-305"
    },
    {
      "procedureNumber": "5.1.1",
      "equipmentId": "EQ-FIT-306",
      "location": "Suite-301, Building 12",
      "equipmentType": "Filter Integrity Tester",
      "description": "Sartocheck 5 Plus, up to 8 bar (pre/post-use integrity for all filters)",
      "actualStartDate": "26-Jan-2026 0:00:00",
      "actualEndDate": "31-Jan-2026 0:00:00",
      "reservationId": "RES-306"
    },
    {
      "procedureNumber": "10.1.1",
      "equipmentId": "EQ-FMV-401",
      "location": "Suite-401, Building 14 (Grade C)",
      "equipmentType": "Formulation Vessel",
      "description": "Stainless steel jacketed mixing vessel, 500 L (DS formulation in full buffer)",
      "actualStartDate": "31-Jan-2026 0:00:00",
      "actualEndDate": "31-Jan-2026 0:00:00",
      "reservationId": "RES-401"
    },
    {
      "procedureNumber": "10.1.1",
      "equipmentId": "EQ-BAL-402",
      "location": "Suite-401, Building 14",
      "equipmentType": "Analytical Balance",
      "description": "Mettler Toledo XPR10001L, 10 kg / 0.1 g (excipient dispensing)",
      "actualStartDate": "31-Jan-2026 0:00:00",
      "actualEndDate": "31-Jan-2026 0:00:00",
      "reservationId": "RES-402"
    },
    {
      "procedureNumber": "11.1.1",
      "equipmentId": "EQ-BFR-501",
      "location": "Suite-402, Building 14 (Grade C)",
      "equipmentType": "DS Bag Fill Rig",
      "description": "Single-use bag fill manifold rig with 3 x 10-bag manifolds; gravimetric fill control, ~30 bags/hr",
      "actualStartDate": "1-Feb-2026 0:00:00",
      "actualEndDate": "1-Feb-2026 0:00:00",
      "reservationId": "RES-501"
    },
    {
      "procedureNumber": "11.1.1",
      "equipmentId": "EQ-SF-502",
      "location": "Suite-402, Building 14",
      "equipmentType": "Sterile Filter Housing",
      "description": "Stainless filter housing for 0.22 um Millipak-200 sterile filter (pre-bag fill)",
      "actualStartDate": "1-Feb-2026 0:00:00",
      "actualEndDate": "1-Feb-2026 0:00:00",
      "reservationId": "RES-502"
    },
    {
      "procedureNumber": "11.1.1",
      "equipmentId": "EQ-FRZ-701",
      "location": "Suite-501, Building 14 (Grade C)",
      "equipmentType": "Controlled Rate Freezer",
      "description": "Sartorius Celsius FFT (Flexible Freeze Thaw) system, -1 C/min controlled ramp, holds 30 x 1 L bags per cycle",
      "actualStartDate": "2-Feb-2026 0:00:00",
      "actualEndDate": "2-Feb-2026 0:00:00",
      "reservationId": "RES-701"
    },
    {
      "procedureNumber": "11.1.1",
      "equipmentId": "EQ-CSV-702",
      "location": "Building 14 - Cold Storage Vault",
      "equipmentType": "Cold Storage Vault",
      "description": "DS storage vault CSV-04 at -40 C +/- 5 C, mapped storage; QR-coded bag rack positions",
      "actualStartDate": "2-Feb-2026 0:00:00",
      "actualEndDate": "6-Feb-2026 0:00:00",
      "reservationId": "RES-702"
    },
    {
      "procedureNumber": "12.1.1",
      "equipmentId": "EQ-SHP-703",
      "location": "Logistics - Shipping Dock",
      "equipmentType": "Qualified Shipper",
      "description": "Va-Q-tec phase-change shipper, -40 C qualified for 96 hours (DS to DP site)",
      "actualStartDate": "17-Feb-2026 0:00:00",
      "actualEndDate": "17-Feb-2026 0:00:00",
      "reservationId": "RES-703"
    }
  ],
  "2388-OXB-A-1": [
    {
      "procedureNumber": "2.1.1",
      "equipmentId": "GMP6_STR50",
      "location": "Suite-102, Building 8 (Grade C)",
      "equipmentType": "Seed Bioreactor",
      "description": "Sartorius Biostat STR 50 L single-use (N-1 seed, CSP4)",
      "actualStartDate": "09-MAY-2025 12:00",
      "actualEndDate": "12-MAY-2025 16:00",
      "reservationId": "RSV-2388-001"
    },
    {
      "procedureNumber": "3.1.1",
      "equipmentId": "GMP6_STR200",
      "location": "Suite-103, Building 8 (Grade C)",
      "equipmentType": "Production Bioreactor",
      "description": "200 L single-use STR, HEK293T, perfusion-enabled (CSP5)",
      "actualStartDate": "12-MAY-2025 12:00",
      "actualEndDate": "16-MAY-2025 11:00",
      "reservationId": "RSV-2388-002"
    },
    {
      "procedureNumber": "3.8.1",
      "equipmentId": "KTF (P-101 / FE-301)",
      "location": "Suite-103, Building 8 (Grade C)",
      "equipmentType": "Perfusion Skid",
      "description": "Perfusion controller: feed pump P-101 & feed flowmeter FE-301",
      "actualStartDate": "13-MAY-2025 12:00",
      "actualEndDate": "16-MAY-2025 09:50",
      "reservationId": "RSV-2388-003"
    },
    {
      "procedureNumber": "4.2.1",
      "equipmentId": "Clarification Skid",
      "location": "Suite-104, Building 8 (Grade C)",
      "equipmentType": "Clarification",
      "description": "0.2 um clarification train; 650 L harvest bag",
      "actualStartDate": "16-MAY-2025 12:00",
      "actualEndDate": "16-MAY-2025 14:30",
      "reservationId": "RSV-2388-004"
    },
    {
      "procedureNumber": "5.1.1",
      "equipmentId": "AIEX Skid",
      "location": "Suite-104, Building 8 (Grade C)",
      "equipmentType": "Chromatography",
      "description": "Anion-exchange skid, Sartobind Q",
      "actualStartDate": "16-MAY-2025 16:45",
      "actualEndDate": "16-MAY-2025 20:46",
      "reservationId": "RSV-2388-006"
    },
    {
      "procedureNumber": "6.1.1",
      "equipmentId": "CIEX Skid",
      "location": "Suite-104, Building 8 (Grade C)",
      "equipmentType": "Chromatography",
      "description": "Cation-exchange skid, Sartobind S",
      "actualStartDate": "16-MAY-2025 14:08",
      "actualEndDate": "16-MAY-2025 16:45",
      "reservationId": "RSV-2388-005"
    },
    {
      "procedureNumber": "7.1.1",
      "equipmentId": "SAN Mixing",
      "location": "Suite-104, Building 8 (Grade C)",
      "equipmentType": "Nuclease Treatment",
      "description": "SAN addition to elution peak bag",
      "actualStartDate": "16-MAY-2025 19:30",
      "actualEndDate": "17-MAY-2025 01:20",
      "reservationId": "RSV-2388-007"
    },
    {
      "procedureNumber": "7.2.1",
      "equipmentId": "HFF Skid",
      "location": "Suite-105, Building 8 (Grade C)",
      "equipmentType": "HFF / TFF",
      "description": "Hollow-fibre UF/DF skid (concentration + DF1)",
      "actualStartDate": "17-MAY-2025 01:00",
      "actualEndDate": "17-MAY-2025 02:50",
      "reservationId": "RSV-2388-008"
    },
    {
      "procedureNumber": "8.1.1",
      "equipmentId": "Aliquoting & Blast Freezer",
      "location": "Suite-105, Building 8 (Grade B)",
      "equipmentType": "Aliquoting / Freezing",
      "description": "Aliquot dispenser + blast freezer",
      "actualStartDate": "17-MAY-2025 03:30",
      "actualEndDate": "17-MAY-2025 05:00",
      "reservationId": "RSV-2388-009"
    }
  ],
  "2785-OXB-B-1": [
    {
      "procedureNumber": "2.1.1",
      "equipmentId": "GMP6_STR50",
      "location": "Suite-102, Building 8 (Grade C)",
      "equipmentType": "Seed Bioreactor",
      "description": "Sartorius Biostat STR 50 L single-use (N-1 seed, CSP4)",
      "actualStartDate": "10-OCT-2025 12:00",
      "actualEndDate": "13-OCT-2025 16:00",
      "reservationId": "RSV-2785-001"
    },
    {
      "procedureNumber": "3.1.1",
      "equipmentId": "GMP6_STR200",
      "location": "Suite-103, Building 8 (Grade C)",
      "equipmentType": "Production Bioreactor",
      "description": "200 L single-use STR, HEK293T, perfusion-enabled (CSP5)",
      "actualStartDate": "13-OCT-2025 12:00",
      "actualEndDate": "17-OCT-2025 14:00",
      "reservationId": "RSV-2785-002"
    },
    {
      "procedureNumber": "3.8.1",
      "equipmentId": "KTF (P-101 / FE-301)",
      "location": "Suite-103, Building 8 (Grade C)",
      "equipmentType": "Perfusion Skid",
      "description": "Perfusion controller: feed pump P-101 & feed flowmeter FE-301",
      "actualStartDate": "14-OCT-2025 12:00",
      "actualEndDate": "17-OCT-2025 13:00",
      "reservationId": "RSV-2785-003"
    },
    {
      "procedureNumber": "4.2.1",
      "equipmentId": "Clarification Skid",
      "location": "Suite-104, Building 8 (Grade C)",
      "equipmentType": "Clarification",
      "description": "0.2 um clarification train; 650 L harvest bag",
      "actualStartDate": "17-OCT-2025 15:00",
      "actualEndDate": "17-OCT-2025 17:30",
      "reservationId": "RSV-2785-004"
    },
    {
      "procedureNumber": "5.1.1",
      "equipmentId": "AIEX Skid",
      "location": "Suite-104, Building 8 (Grade C)",
      "equipmentType": "Chromatography",
      "description": "Anion-exchange skid, Sartobind Q",
      "actualStartDate": "17-OCT-2025 19:30",
      "actualEndDate": "17-OCT-2025 22:15",
      "reservationId": "RSV-2785-006"
    },
    {
      "procedureNumber": "6.1.1",
      "equipmentId": "CIEX Skid",
      "location": "Suite-104, Building 8 (Grade C)",
      "equipmentType": "Chromatography",
      "description": "Cation-exchange skid, Sartobind S",
      "actualStartDate": "17-OCT-2025 17:15",
      "actualEndDate": "17-OCT-2025 19:30",
      "reservationId": "RSV-2785-005"
    },
    {
      "procedureNumber": "7.1.1",
      "equipmentId": "SAN Mixing",
      "location": "Suite-104, Building 8 (Grade C)",
      "equipmentType": "Nuclease Treatment",
      "description": "SAN addition to elution peak bag",
      "actualStartDate": "17-OCT-2025 22:00",
      "actualEndDate": "17-OCT-2025 23:30",
      "reservationId": "RSV-2785-007"
    },
    {
      "procedureNumber": "7.2.1",
      "equipmentId": "HFF Skid",
      "location": "Suite-105, Building 8 (Grade C)",
      "equipmentType": "HFF / TFF",
      "description": "Hollow-fibre UF/DF skid (concentration + DF1)",
      "actualStartDate": "17-OCT-2025 23:00",
      "actualEndDate": "18-OCT-2025 01:15",
      "reservationId": "RSV-2785-008"
    },
    {
      "procedureNumber": "8.1.1",
      "equipmentId": "Aliquoting & Blast Freezer",
      "location": "Suite-105, Building 8 (Grade B)",
      "equipmentType": "Aliquoting / Freezing",
      "description": "Aliquot dispenser + blast freezer",
      "actualStartDate": "18-OCT-2025 01:30",
      "actualEndDate": "18-OCT-2025 03:00",
      "reservationId": "RSV-2785-009"
    }
  ]
};

export const PLANNED_CC_DATA = {
  "TZB2401-DS": [
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2026-101",
      "cmoCCNumber": "CMO-PCC-2026-101",
      "initialDocNumber": "SOP-MFG-PB-FEED-002 v.04",
      "finalDocNumber": "SOP-MFG-PB-FEED-002 v.06",
      "changeFrom": "Production bioreactor feed: bolus addition of Feed Medium A (10% v/v daily) and Feed Medium B (2% v/v daily) on days 3, 5, 7, 9, 11. Manual addition.",
      "changeTo": "Continuous feed via Raman spectroscopy-based glucose monitoring with automated feed control (PAT). Feed A continuous to maintain glucose at 4.0 +/- 0.5 g/L; Feed B continued as daily bolus. Manual override available.",
      "reasonsForChange": "Continuous improvement. Real-time glucose control improves consistency of glycosylation (G0F/G1F, afucosylation) and expected to increase titer 10-15%. Aligns with ICH Q8/Q9/Q10. Supports future PACMP filing.  Affected ISA-88 procedure: 3.2 (Production bioreactor feeding).",
      "ccClosureReport": {
        "name": "CMO-PCC-2026-101.Change_Control_Closure_Report.pdf",
        "timestamp": "10-Feb-2026 11:00:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    },
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2026-103",
      "cmoCCNumber": "CMO-PCC-2026-103",
      "initialDocNumber": "SOP-MFG-PB-001 v.06 / EQ-BR-202 IQ/OQ/PQ",
      "finalDocNumber": "SOP-MFG-PB-001 v.07 / EQ-BR-204 IQ/OQ/PQ",
      "changeFrom": "Production bioreactor BR-202 (2000 L stainless steel, CIP/SIP). Turnaround 72 hours including cleaning. Cross-product cleaning verification.",
      "changeTo": "Introduce single-use bioreactor BR-204 (2000 L Sartorius Biostat STR) as alternate to BR-202. Single-use bag replaced between batches; no CIP/SIP. Turnaround 24 hours. Comparability: 3 engineering + 3 PPQ batches.",
      "reasonsForChange": "Capacity and turnaround. Single-use eliminates cleaning validation burden. Supports demand without facility expansion. Comparability filed as PAS (FDA) / Type II Variation (EMA).  Affected ISA-88 procedure: 3.1 (Production bioreactor).",
      "ccClosureReport": {
        "name": "CMO-PCC-2026-103.Change_Control_Closure_Report.pdf",
        "timestamp": "14-Feb-2026 09:45:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    },
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2026-105",
      "cmoCCNumber": "CMO-PCC-2026-105",
      "initialDocNumber": "STAB-PROT-TZB-DS-001 v.04",
      "finalDocNumber": "STAB-PROT-TZB-DS-001 v.05",
      "changeFrom": "DS stability program in 1 L Flexsafe 2D bags at -40 C: time points 0, 3, 6, 9, 12, 18, 24 months. Approved DS hold time: 24 months at -40 C +/- 5 C.",
      "changeTo": "DS stability program extended: time points added at 30 and 36 months. Frozen DS hold extended from 24 to 36 months at -40 C +/- 5 C. Stability-indicating CQAs (HMW, charge variants, afucosylation, potency) tested at every time point.",
      "reasonsForChange": "Operational flexibility. 36-month DS hold supports decoupled DS / DP scheduling, reduces write-offs, and provides buffer against fill site capacity constraints. Filed as Type II variation (EMA) / PAS (FDA).  Affected ISA-88 procedure: 11 (Fill & Freeze) / DS storage.",
      "ccClosureReport": {
        "name": "CMO-PCC-2026-105.Change_Control_Closure_Report.pdf",
        "timestamp": "14-Feb-2026 16:00:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    },
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2026-106",
      "cmoCCNumber": "CMO-PCC-2026-106",
      "initialDocNumber": "SPEC-CC-BAG-001 v.02 / AVL-002 v.08",
      "finalDocNumber": "SPEC-CC-BAG-001 v.03 / AVL-002 v.09",
      "changeFrom": "DS storage bag: Sartorius Flexsafe 2D 1 L (EVA film, gamma-irradiated). Sole-source.",
      "changeTo": "Add Pall Allegro 1 L (EVA film, gamma-irradiated) as qualified second source. Extractables/leachables comparability per USP <1663>/<1664> across 3 DS batches confirmed equivalent.",
      "reasonsForChange": "Supply chain resilience. Sole-source for primary DS container is a regulatory and business continuity risk. Dual sourcing strengthens supply assurance.  Affected ISA-88 procedure: 11.1 (DS bag fill).",
      "ccClosureReport": {
        "name": "CMO-PCC-2026-106.Change_Control_Closure_Report.pdf",
        "timestamp": "15-Feb-2026 10:30:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    }
  ],
  "2388-OXB-A-1": [
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2025-088",
      "cmoCCNumber": "CMO-PCC-2025-088",
      "initialDocNumber": "SOP-QC-TIT-011 v.01",
      "finalDocNumber": "SOP-QC-TIT-011 v.02",
      "changeFrom": "Infectious titre by qPCR-based transduction assay (96-well plate readout).",
      "changeTo": "Introduce droplet digital PCR (ddPCR) for infectious/physical titre to reduce assay variability and improve inter-run precision. Comparability bridging across 3 DS lots.",
      "reasonsForChange": "Analytical robustness. ddPCR lowers titre CV and improves quantitation at low copy number, supporting tighter release specifications.",
      "ccClosureReport": {
        "name": "CMO-PCC-2025-088.Change_Control_Closure_Report.pdf",
        "timestamp": "2025-06-04T10:15:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    },
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2025-090",
      "cmoCCNumber": "CMO-PCC-2025-090",
      "initialDocNumber": "SOP-DSP-FILL-007 v.02",
      "finalDocNumber": "SOP-DSP-FILL-007 v.03",
      "changeFrom": "Bulk DS aliquots blast-frozen in a static -80 C freezer.",
      "changeTo": "Introduce controlled-rate freezing (CRF) for bulk DS aliquots to standardise the cooling profile and improve infectious-titre recovery on thaw. Comparability on engineering + confirmation lots.",
      "reasonsForChange": "Product quality / consistency. A defined cooling rate reduces freeze-induced titre loss and vial-to-vial variability of the enveloped vector.",
      "ccClosureReport": {
        "name": "CMO-PCC-2025-090.Change_Control_Closure_Report.pdf",
        "timestamp": "2025-06-06T14:30:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Under Review"
    },
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2025-092",
      "cmoCCNumber": "CMO-PCC-2025-092",
      "initialDocNumber": "SOP-DSP-CLAR-003 v.01",
      "finalDocNumber": "SOP-DSP-CLAR-003 v.02",
      "changeFrom": "Single-stage 0.2 um clarification of the nuclease-treated harvest.",
      "changeTo": "Add an upstream depth-filtration stage (dual-stage clarification) ahead of the 0.2 um filter to reduce turbidity load and filter fouling at scale.",
      "reasonsForChange": "Process robustness / scalability. Dual-stage clarification lowers differential pressure and improves filter capacity for larger production volumes.",
      "ccClosureReport": {
        "name": "CMO-PCC-2025-092.Change_Control_Closure_Report.pdf",
        "timestamp": "2025-06-09T11:00:00"
      },
      "sponsorCCStatus": "Approved",
      "cmoCCStatus": "Open"
    }
  ],
  "2785-OXB-B-1": [
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2025-121",
      "cmoCCNumber": "CMO-PCC-2025-121",
      "initialDocNumber": "SOP-MFG-TX-003 v.02",
      "finalDocNumber": "SOP-MFG-TX-003 v.03",
      "changeFrom": "Transient 4-plasmid transfection with PEIpro in single-use STR. Batch-defined transfection each run.",
      "changeTo": "Introduce a stable packaging/producer HEK293 cell line (inducible) to remove per-batch plasmid transfection. Comparability: engineering + PPQ lots; titer, RCL, purity bridging.",
      "reasonsForChange": "Process robustness and cost. A stable producer line reduces plasmid/PEI variability, improves titer consistency, and simplifies scale-up. Filed as PAS (FDA) / Type II Variation (EMA).  Affected ISA-88 procedure: 3.4 (Transfection).",
      "ccClosureReport": {
        "name": "CMO-PCC-2025-121.Change_Control_Closure_Report.pdf",
        "timestamp": "2025-11-05T11:00:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    },
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2025-123",
      "cmoCCNumber": "CMO-PCC-2025-123",
      "initialDocNumber": "SOP-DSP-AEX-005 v.02",
      "finalDocNumber": "SOP-DSP-AEX-005 v.03",
      "changeFrom": "AIEX capture on single qualified Sartobind Q source. Sole-source membrane.",
      "changeTo": "Qualify a second-source AIEX membrane as alternate capture. Extractables/leachables and clearance comparability across 3 DS lots confirmed equivalent.",
      "reasonsForChange": "Supply-chain resilience. Sole-source capture membrane is a business-continuity risk. Dual sourcing strengthens supply assurance.  Affected ISA-88 procedure: 5 (Anion Exchange, AEX).",
      "ccClosureReport": {
        "name": "CMO-PCC-2025-123.Change_Control_Closure_Report.pdf",
        "timestamp": "2025-11-07T09:45:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    },
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2025-125",
      "cmoCCNumber": "CMO-PCC-2025-125",
      "initialDocNumber": "STAB-PROT-LVV-DS-001 v.02",
      "finalDocNumber": "STAB-PROT-LVV-DS-001 v.03",
      "changeFrom": "Frozen DS stability at <= -70 C: time points 0, 3, 6, 9, 12 months. Approved DS hold: 12 months.",
      "changeTo": "DS stability extended: time points added at 18 and 24 months. Frozen DS hold extended from 12 to 24 months at <= -70 C. Infectious titer, potency, aggregation tested at each point.",
      "reasonsForChange": "Operational flexibility. A 24-month DS hold supports decoupled DS / CAR-T fill scheduling and reduces write-offs. Filed as Type II Variation (EMA) / PAS (FDA).  Affected ISA-88 procedure: 8 (Aliquoting & Freeze) / DS storage.",
      "ccClosureReport": {
        "name": "CMO-PCC-2025-125.Change_Control_Closure_Report.pdf",
        "timestamp": "2025-11-07T16:00:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    },
    {
      "ccType": "Planned",
      "sponsorCCNumber": "SCC-2025-126",
      "cmoCCNumber": "CMO-PCC-2025-126",
      "initialDocNumber": "SOP-DSP-TFF-004 v.01",
      "finalDocNumber": "SOP-DSP-TFF-004 v.02",
      "changeFrom": "HFF concentration on hollow-fibre membrane, manual permeate flux control.",
      "changeTo": "Introduce single-pass TFF (SPTFF) with automated flux control to reduce shear exposure of the enveloped vector and improve infectious-titer recovery.",
      "reasonsForChange": "Continuous improvement. Reduced shear residence time is expected to improve specific infectivity and step yield by 10-20%. Supports future PACMP filing.  Affected ISA-88 procedure: 7.3-7.4 (UDFD concentration/diafiltration).",
      "ccClosureReport": {
        "name": "CMO-PCC-2025-126.Change_Control_Closure_Report.pdf",
        "timestamp": "2025-11-10T10:30:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    }
  ]
};

// Unplanned "Change Control" sheet — only TZB2401-DS has rows (reactive CAPAs
// closing deviations); 2388/2785 unplanned CC sheets are empty. Shown by the
// Change Control tab ahead of the Planned Change Control rows.
export const CHANGE_CONTROL_DATA = {
  "TZB2401-DS": [
    {
      "ccType": "Stage",
      "sponsorCCNumber": "SCC-2026-008",
      "cmoCCNumber": "CMO-CC-2026-031",
      "initialDocNumber": "SOP-MFG-PB-007 v.05",
      "finalDocNumber": "SOP-MFG-PB-007 v.06",
      "changeFrom": "Production bioreactor TCU single chilled water valve. Annual PM. Alarm response refresher every 24 months.",
      "changeTo": "Redundant chilled water valve on all 2000 L bioreactors. PM frequency semi-annual. Alarm refresher every 12 months. Daily checkpoint added to verify both valves operational.",
      "reasonsForChange": "Closes CAPA from deviation QE-2026-011 (TZB2401-DS day-9 temperature excursion). Single point of failure on chilled water supply was root cause.",
      "ccClosureReport": {
        "name": "CMO-CC-2026-031.Change_Control_Closure_Report.pdf",
        "timestamp": "14-Feb-2026 09:30:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    },
    {
      "ccType": "Stage",
      "sponsorCCNumber": "SCC-2026-009",
      "cmoCCNumber": "CMO-CC-2026-032",
      "initialDocNumber": "MBPR-TZB-F-003 v.04",
      "finalDocNumber": "MBPR-TZB-F-003 v.05",
      "changeFrom": "Neutralization buffer prepared on day of viral inactivation. Max hold alarm 120 min. No upstream readiness check before low pH hold.",
      "changeTo": "Neutralization buffer pre-staged 24 h before viral inactivation, held at 2-8 C. Max hold alarm tightened to 100 min. Mandatory operator checkpoint to confirm buffer ready before pH adjust.",
      "reasonsForChange": "Closes CAPA from deviation QE-2026-013 (low pH hold extended to 142 min). Viral clearance steps must operate strictly within validated ranges per ICH Q5A.",
      "ccClosureReport": {
        "name": "CMO-CC-2026-032.Change_Control_Closure_Report.pdf",
        "timestamp": "14-Feb-2026 10:45:00"
      },
      "sponsorCCStatus": "Closed",
      "cmoCCStatus": "Closed"
    }
  ]
};

export const DEVIATION_DATA = {
  "TZB2401-DS": [
    {
      "deviationNumber": "QE-2026-011",
      "reportingDate": "20-Jan-2026 / 3.3.2 (PBR day-9 temp excursion)",
      "initialDescription": "Production bioreactor temperature excursion: reactor temperature rose to 38.2 C for 45 minutes on day 9 of fed-batch culture (spec: 36.5 - 37.5 C). Root cause: TCU chilled water valve malfunction.",
      "assessmentReport": {
        "name": "QE-2026-011.Deviation_Assessment_Report.pdf",
        "timestamp": "20-Jan-2026 14:30:00"
      },
      "finalReport": {
        "name": "QE-2026-011.Final_Deviation_Report.pdf",
        "timestamp": "22-Jan-2026 09:15:00"
      },
      "correctiveAction": {
        "text": "Cell viability and titer assessed; both within acceptance. Expanded CQA testing on Protein A eluate. Batch released to harvest."
      },
      "cmoCAStatus": "Closed",
      "preventiveAction": {
        "text": "TCU PM frequency increased to semi-annual. Redundant chilled water valve installed on all 2000 L bioreactors. Operators retrained on TCU alarm response."
      },
      "cmoPAStatus": "Closed",
      "deviationStatus": "Closed",
      "deviationCategory": "Major",
      "deviationType": "Process",
      "informedSponsor": "Yes",
      "sponsorDeviationStatus": "Closed",
      "sponsorDeviationId": "SP-QE-2026-0011"
    },
    {
      "deviationNumber": "QE-2026-013",
      "reportingDate": "27-Jan-2026 / 6.1.2 (low-pH viral inactivation hold)",
      "initialDescription": "Low pH viral inactivation hold extended beyond validated upper limit. Target: 60-90 min at pH 3.3-3.7. Actual: 142 minutes due to delayed neutralization buffer preparation. pH within range throughout.",
      "assessmentReport": {
        "name": "QE-2026-013.Deviation_Assessment_Report.pdf",
        "timestamp": "27-Jan-2026 19:45:00"
      },
      "finalReport": {
        "name": "QE-2026-013.Final_Deviation_Report.pdf",
        "timestamp": "28-Jan-2026 10:30:00"
      },
      "correctiveAction": {
        "text": "Extended hold assessed against stability data: aggregation, charge variants, potency all within acceptance. Batch released to polishing."
      },
      "cmoCAStatus": "Closed",
      "preventiveAction": {
        "text": "Neutralization buffer prep moved to pre-stage activity (24 h prior). Max hold alarm tightened from 120 to 100 min. SOP updated for buffer readiness confirmation."
      },
      "cmoPAStatus": "Closed",
      "deviationStatus": "Closed",
      "deviationCategory": "Major",
      "deviationType": "Process",
      "informedSponsor": "Yes",
      "sponsorDeviationStatus": "Closed",
      "sponsorDeviationId": "SP-QE-2026-0013"
    },
    {
      "deviationNumber": "QE-2026-019",
      "reportingDate": "02-Feb-2026 / 11.3.1 (controlled-rate freeze cycle)",
      "initialDescription": "Controlled rate freeze deviation: bag positions #14-#16 reached -40 C end-point ~8 minutes later than the validated cycle envelope (-40 C +/- 2 C within 240 minutes). Cause: shelf airflow imbalance in freezer FZ-02 caused by misaligned rear diffuser plate.",
      "assessmentReport": {
        "name": "QE-2026-019.Deviation_Assessment_Report.pdf",
        "timestamp": "02-Feb-2026 21:00:00"
      },
      "finalReport": {
        "name": "QE-2026-019.Final_Deviation_Report.pdf",
        "timestamp": "04-Feb-2026 11:30:00"
      },
      "correctiveAction": {
        "text": "Affected bags assessed against extended freeze profile; all CQAs within acceptance. Bags retained in DS storage at -40 C."
      },
      "cmoCAStatus": "Closed",
      "preventiveAction": {
        "text": "Freezer FZ-02 diffuser plate realigned and re-qualified. Pre-cycle shelf temperature mapping added to BPR. Freezer PQ frequency increased from annual to semi-annual."
      },
      "cmoPAStatus": "Closed",
      "deviationStatus": "Closed",
      "deviationCategory": "Major",
      "deviationType": "Equipment",
      "informedSponsor": "Yes",
      "sponsorDeviationStatus": "Closed",
      "sponsorDeviationId": "SP-QE-2026-0019"
    },
    {
      "deviationNumber": "QE-2026-020",
      "reportingDate": "01-Feb-2026 / 11.1.1 (DS bag fill weight)",
      "initialDescription": "DS bag fill weight out-of-trend: bags #21-#23 from manifold #3 weighed 0.972, 0.968, 0.971 kg (spec: 1.000 +/- 0.020 kg). Within specification but at lower edge of range. Cause: tubing pinch in manifold #3 caused intermittent low flow.",
      "assessmentReport": {
        "name": "QE-2026-020.Deviation_Assessment_Report.pdf",
        "timestamp": "01-Feb-2026 19:30:00"
      },
      "finalReport": {
        "name": "QE-2026-020.Final_Deviation_Report.pdf",
        "timestamp": "03-Feb-2026 10:00:00"
      },
      "correctiveAction": {
        "text": "Manifold #3 stopped, tubing inspected and repositioned. Affected bags (3 of 30) individually weighed and accepted; recorded as lower DS volume per bag in inventory."
      },
      "cmoCAStatus": "Closed",
      "preventiveAction": {
        "text": "Manifold pre-use inspection checklist updated to include tubing path verification. In-line bag weight sensor with auto-stop on >1.5% deviation specified for next generation fill rig."
      },
      "cmoPAStatus": "Closed",
      "deviationStatus": "Closed",
      "deviationCategory": "Major",
      "deviationType": "Equipment",
      "informedSponsor": "Yes",
      "sponsorDeviationStatus": "Closed",
      "sponsorDeviationId": "SP-QE-2026-0020"
    }
  ],
  "2388-OXB-A-1": [
    {
      "deviationNumber": "DEV-5842",
      "reportingDate": "14-MAY-2025 / 3.4.1 (Transfection - VCD verification)",
      "initialDescription": "DEV-5842 - Viable cell density at transfection (4.62 x10^6 cells/mL) exceeded the upper BMR action limit of the target range (2.0 - 4.0 x10^6 cells/mL). The 200 L production culture reached a higher-than-expected VCD at the point of transfection-complex addition.",
      "assessmentReport": {
        "name": "DEV-5842.Deviation_Assessment_Report.pdf",
        "timestamp": "2025-05-16T14:00:00"
      },
      "finalReport": {
        "name": "DEV-5842.Final_Deviation_Report.pdf",
        "timestamp": "2025-05-23T15:30:00",
        "note": "Closed. Root cause: N-1 seed expansion delivered a higher-than-target inoculation density, compounded by a marginally extended pre-transfection culture duration (48h 11min vs 48h target), giving a VCD just above the range. Product-impact assessment: no adverse impact - downstream titre, purity and potency all within acceptance criteria."
      },
      "correctiveAction": {
        "text": "Transfection proceeded per BMR; transfection-complex volume verified appropriate for the measured VCD. Post-transfection viability (97.8%) and final release titre confirmed no product impact. CMO CA: Complete."
      },
      "cmoCAStatus": "Complete",
      "preventiveAction": {
        "text": "N-1 seed target-density verification added prior to production-bioreactor inoculation; VCD trending review introduced at 200 L Day 2 to allow pre-transfection dilution if projected VCD approaches the upper action limit. CMO PA: Complete."
      },
      "cmoPAStatus": "Complete",
      "deviationStatus": "Closed",
      "deviationCategory": "Minor",
      "deviationType": "Process",
      "informedSponsor": "Yes",
      "sponsorDeviationStatus": "Closed",
      "sponsorDeviationId": "SP-DEV-2025-5842"
    }
  ],
  "2785-OXB-B-1": [
    {
      "deviationNumber": "DEV-5970",
      "reportingDate": "16-OCT-2025 / 3.8.1 (Perfusion C initiation)",
      "initialDescription": "DEV-5970 - Time between Perfusion B completion and Perfusion C initiation breached the BMR range due to KTF issues. On starting Perfusion C, feed flowmeter FE-301 did not initiate. Operators performed 7 HMI restarts and 2 hard restarts of the KTF (with IT), maintaining set points between restarts; FE-301 still did not initiate. Engineering found a \"Power Output not Active\" fault on the feed-pump (P-101) controller cable, reset button not functioning in Auto mode. Operators manually ran P-101 to clear the alarm and engage the pump; Perfusion C was then initiated at 21:19. Root cause to be investigated in the DI.",
      "assessmentReport": {
        "name": "DEV-5970.Deviation_Assessment_Report.pdf",
        "timestamp": "2025-10-18T11:20:00"
      },
      "finalReport": {
        "name": "DEV-5970.Final_Deviation_Report.pdf",
        "timestamp": "2025-10-28T15:00:00",
        "note": "Closed. Root cause: feed-pump P-101 controller 'Power Output not Active' fault (reset inoperative in Auto mode); FE-301 flow did not initiate at Perfusion B->C transition. No product impact - Production Bioreactor completed to harvest within criteria; titer/quality unaffected."
      },
      "correctiveAction": {
        "text": "Manual P-101 recovery cleared the alarm and engaged the pump; Perfusion C initiated 21:19 and completed to rapid harvest. CMO CA Status: Closed 28-Oct-2025."
      },
      "cmoCAStatus": "Closed 28-Oct-2025",
      "preventiveAction": {
        "text": "Pre-Perfusion-C KTF readiness checkpoint implemented: verify P-101 controller power/health and interlock FE-301 flow initiation to a pump-ready state before Perfusion C start; documented manual-recovery contingency. CMO PA Status: Closed 28-Oct-2025."
      },
      "cmoPAStatus": "Closed 28-Oct-2025",
      "deviationStatus": "Open",
      "deviationCategory": "Major",
      "deviationType": "Equipment",
      "informedSponsor": "Yes",
      "sponsorDeviationStatus": "Open",
      "sponsorDeviationId": "SP-DEV-2025-5970"
    }
  ]
};

// Planning tab dataset — the "Planning" sheet of each Manufacturing Collaboration
// workbook. Unlike the other tabs this is not a flat row list but a
// { headerFields, milestones } object: three summary fields (PO Due Date, Open CAPA
// Items, Equipment Reserved) and the milestone timeline. Excel only (no API merge);
// read via selectTabData by the Planning tab.
export const PLANNING_DATA = {
  "2388-OXB-A-1": {
    "headerFields": [
      { "label": "PO Due Date", "value": "03-JUN-2025", "timestamp": "08-APR-2025 09:00:00" },
      { "label": "Open CAPA Items", "value": "0", "timestamp": "23-MAY-2025 15:30:00" },
      { "label": "Equipment Reserved", "value": "Yes (9 items)", "timestamp": "24-APR-2025 09:00:00" }
    ],
    "milestones": [
      { "item": "Equipment Reservation Confirmed", "targetDate": "24-APR-2025", "expectedDate": "24-APR-2025", "actualDate": "24-APR-2025", "lastUpdate": "24-APR-2025 09:00:00" },
      { "item": "Raw Materials Order Placed", "targetDate": "08-APR-2025", "expectedDate": "08-APR-2025", "actualDate": "08-APR-2025", "lastUpdate": "08-APR-2025 09:00:00" },
      { "item": "Raw Materials Received at CMO", "targetDate": "18-APR-2025", "expectedDate": "18-APR-2025", "actualDate": "18-APR-2025", "lastUpdate": "18-APR-2025 14:00:00" },
      { "item": "CMO RM Release (QC Approved)", "targetDate": "24-APR-2025", "expectedDate": "24-APR-2025", "actualDate": "24-APR-2025", "lastUpdate": "24-APR-2025 16:00:00" },
      { "item": "CMO MFG Start (HEK293T Cell Thaw)", "targetDate": "26-APR-2025", "expectedDate": "26-APR-2025", "actualDate": "26-APR-2025", "lastUpdate": "26-APR-2025 10:27:00" },
      { "item": "N-1 Seed Bioreactor Inoculation (50 L SUB)", "targetDate": "09-MAY-2025", "expectedDate": "09-MAY-2025", "actualDate": "09-MAY-2025", "lastUpdate": "09-MAY-2025 17:28:00" },
      { "item": "Production Bioreactor Inoculation & Perfusion A (200 L)", "targetDate": "12-MAY-2025", "expectedDate": "12-MAY-2025", "actualDate": "12-MAY-2025", "lastUpdate": "12-MAY-2025 15:44:00" },
      { "item": "Transfection Complete (U1 + PEIpro)", "targetDate": "14-MAY-2025", "expectedDate": "14-MAY-2025", "actualDate": "14-MAY-2025", "lastUpdate": "14-MAY-2025 15:27:00" },
      { "item": "Induction (Sodium Butyrate) & Perfusion B Complete", "targetDate": "15-MAY-2025", "expectedDate": "15-MAY-2025", "actualDate": "15-MAY-2025", "lastUpdate": "15-MAY-2025 17:34:00" },
      { "item": "Perfusion C, Rapid Harvest & Benzonase Complete", "targetDate": "16-MAY-2025", "expectedDate": "16-MAY-2025", "actualDate": "16-MAY-2025", "lastUpdate": "16-MAY-2025 10:51:00" },
      { "item": "Downstream Complete (Clarification / CIEX / AIEX / SAN / HFF-DF)", "targetDate": "17-MAY-2025", "expectedDate": "17-MAY-2025", "actualDate": "17-MAY-2025", "lastUpdate": "17-MAY-2025 02:45:00" },
      { "item": "Bulk DS Aliquoting & Blast Freeze Complete (Mfg Date)", "targetDate": "17-MAY-2025", "expectedDate": "17-MAY-2025", "actualDate": "17-MAY-2025", "lastUpdate": "17-MAY-2025 04:56:00" },
      { "item": "VS Manufactured / DS to Cold Storage", "targetDate": "17-MAY-2025", "expectedDate": "17-MAY-2025", "actualDate": "17-MAY-2025", "lastUpdate": "17-MAY-2025 05:00:00" },
      { "item": "DS Release Sample Pulled for QC", "targetDate": "18-MAY-2025", "expectedDate": "18-MAY-2025", "actualDate": "18-MAY-2025", "lastUpdate": "18-MAY-2025 10:00:00" },
      { "item": "Release Testing Start (Identity, Infectious Titer)", "targetDate": "19-MAY-2025", "expectedDate": "19-MAY-2025", "actualDate": "19-MAY-2025", "lastUpdate": "19-MAY-2025 09:00:00" },
      { "item": "Release Testing - Process Residuals (HCP, resDNA, Benzonase)", "targetDate": "21-MAY-2025", "expectedDate": "21-MAY-2025", "actualDate": "21-MAY-2025", "lastUpdate": "21-MAY-2025 12:00:00" },
      { "item": "Release Testing - Microbial (Sterility, Myco, LAL)", "targetDate": "23-MAY-2025", "expectedDate": "23-MAY-2025", "actualDate": "23-MAY-2025", "lastUpdate": "23-MAY-2025 12:00:00" },
      { "item": "Release Testing Complete (Potency + RCL)", "targetDate": "23-MAY-2025", "expectedDate": "23-MAY-2025", "actualDate": "23-MAY-2025", "lastUpdate": "23-MAY-2025 16:00:00" },
      { "item": "Deviation DEV-5842 - Closed (final report issued; CA/PA complete)", "targetDate": "23-MAY-2025", "expectedDate": "23-MAY-2025", "actualDate": "23-MAY-2025", "lastUpdate": "23-MAY-2025 15:30:00" },
      { "item": "Batch Documentation Compiled", "targetDate": "26-MAY-2025", "expectedDate": "26-MAY-2025", "actualDate": "26-MAY-2025", "lastUpdate": "26-MAY-2025 17:00:00" },
      { "item": "CMO QA Approval (DS CoA Issued)", "targetDate": "28-MAY-2025", "expectedDate": "28-MAY-2025", "actualDate": "28-MAY-2025", "lastUpdate": "28-MAY-2025 16:00:00" },
      { "item": "Sponsor Document Review", "targetDate": "30-MAY-2025", "expectedDate": "30-MAY-2025", "actualDate": "30-MAY-2025", "lastUpdate": "30-MAY-2025 14:00:00" },
      { "item": "Sponsor DS Release (Disposition)", "targetDate": "03-JUN-2025", "expectedDate": "03-JUN-2025", "actualDate": "03-JUN-2025", "lastUpdate": "03-JUN-2025 11:00:00" }
    ]
  },
  "2785-OXB-B-1": {
    "headerFields": [
      { "label": "PO Due Date", "value": "04-NOV-2025", "timestamp": "08-SEP-2025 09:00:00" },
      { "label": "Open CAPA Items", "value": "0", "timestamp": "28-OCT-2025 15:00:00" },
      { "label": "Equipment Reserved", "value": "Yes (9 items)", "timestamp": "24-SEP-2025 09:00:00" }
    ],
    "milestones": [
      { "item": "Equipment Reservation Confirmed", "targetDate": "24-SEP-2025", "expectedDate": "24-SEP-2025", "actualDate": "24-SEP-2025", "lastUpdate": "24-SEP-2025 09:00:00" },
      { "item": "Raw Materials Order Placed", "targetDate": "08-SEP-2025", "expectedDate": "08-SEP-2025", "actualDate": "08-SEP-2025", "lastUpdate": "08-SEP-2025 09:00:00" },
      { "item": "Raw Materials Received at CMO", "targetDate": "18-SEP-2025", "expectedDate": "18-SEP-2025", "actualDate": "18-SEP-2025", "lastUpdate": "18-SEP-2025 14:00:00" },
      { "item": "CMO RM Release (QC Approved)", "targetDate": "24-SEP-2025", "expectedDate": "24-SEP-2025", "actualDate": "24-SEP-2025", "lastUpdate": "24-SEP-2025 16:00:00" },
      { "item": "CMO MFG Start (HEK293T Cell Thaw)", "targetDate": "26-SEP-2025", "expectedDate": "26-SEP-2025", "actualDate": "26-SEP-2025", "lastUpdate": "26-SEP-2025 10:21:00" },
      { "item": "N-1 Seed Bioreactor Inoculation (50 L SUB)", "targetDate": "10-OCT-2025", "expectedDate": "10-OCT-2025", "actualDate": "10-OCT-2025", "lastUpdate": "10-OCT-2025 17:32:00" },
      { "item": "Production Bioreactor Inoculation & Perfusion A (200 L)", "targetDate": "13-OCT-2025", "expectedDate": "13-OCT-2025", "actualDate": "13-OCT-2025", "lastUpdate": "13-OCT-2025 15:51:00" },
      { "item": "Transfection Complete (U1 + PEIpro)", "targetDate": "15-OCT-2025", "expectedDate": "15-OCT-2025", "actualDate": "15-OCT-2025", "lastUpdate": "15-OCT-2025 14:42:00" },
      { "item": "Induction (Sodium Butyrate) & Perfusion B Complete", "targetDate": "16-OCT-2025", "expectedDate": "16-OCT-2025", "actualDate": "16-OCT-2025", "lastUpdate": "16-OCT-2025 16:53:00" },
      { "item": "Perfusion C, Rapid Harvest & Benzonase Complete", "targetDate": "17-OCT-2025", "expectedDate": "17-OCT-2025", "actualDate": "17-OCT-2025", "lastUpdate": "17-OCT-2025 13:52:00" },
      { "item": "Downstream Complete (Clarification / CIEX / AIEX / SAN / HFF-DF)", "targetDate": "18-OCT-2025", "expectedDate": "18-OCT-2025", "actualDate": "18-OCT-2025", "lastUpdate": "18-OCT-2025 00:59:00" },
      { "item": "Bulk DS Aliquoting & Blast Freeze Complete (Mfg Date)", "targetDate": "18-OCT-2025", "expectedDate": "18-OCT-2025", "actualDate": "18-OCT-2025", "lastUpdate": "18-OCT-2025 02:49:00" },
      { "item": "VS Manufactured / DS to Cold Storage", "targetDate": "18-OCT-2025", "expectedDate": "18-OCT-2025", "actualDate": "18-OCT-2025", "lastUpdate": "18-OCT-2025 03:00:00" },
      { "item": "DS Release Sample Pulled for QC", "targetDate": "19-OCT-2025", "expectedDate": "19-OCT-2025", "actualDate": "19-OCT-2025", "lastUpdate": "19-OCT-2025 10:00:00" },
      { "item": "Release Testing Start (Identity, Infectious Titer)", "targetDate": "20-OCT-2025", "expectedDate": "20-OCT-2025", "actualDate": "20-OCT-2025", "lastUpdate": "20-OCT-2025 09:00:00" },
      { "item": "Release Testing - Process Residuals (HCP, resDNA, Benzonase)", "targetDate": "22-OCT-2025", "expectedDate": "22-OCT-2025", "actualDate": "22-OCT-2025", "lastUpdate": "22-OCT-2025 12:00:00" },
      { "item": "Release Testing - Microbial (Sterility, Myco, LAL)", "targetDate": "24-OCT-2025", "expectedDate": "24-OCT-2025", "actualDate": "24-OCT-2025", "lastUpdate": "24-OCT-2025 12:00:00" },
      { "item": "Release Testing Complete (Potency + RCL)", "targetDate": "24-OCT-2025", "expectedDate": "24-OCT-2025", "actualDate": "24-OCT-2025", "lastUpdate": "24-OCT-2025 16:00:00" },
      { "item": "Deviation DEV-5970 - Closed (final report issued; CA/PA complete)", "targetDate": "28-OCT-2025", "expectedDate": "28-OCT-2025", "actualDate": "28-OCT-2025", "lastUpdate": "28-OCT-2025 15:00:00" },
      { "item": "Batch Documentation Compiled", "targetDate": "27-OCT-2025", "expectedDate": "27-OCT-2025", "actualDate": "27-OCT-2025", "lastUpdate": "27-OCT-2025 17:00:00" },
      { "item": "CMO QA Approval (DS CoA Issued)", "targetDate": "29-OCT-2025", "expectedDate": "29-OCT-2025", "actualDate": "29-OCT-2025", "lastUpdate": "29-OCT-2025 16:00:00" },
      { "item": "Sponsor Document Review", "targetDate": "31-OCT-2025", "expectedDate": "31-OCT-2025", "actualDate": "31-OCT-2025", "lastUpdate": "31-OCT-2025 14:00:00" },
      { "item": "Sponsor DS Release (Disposition)", "targetDate": "04-NOV-2025", "expectedDate": "04-NOV-2025", "actualDate": "04-NOV-2025", "lastUpdate": "04-NOV-2025 11:00:00" }
    ]
  },
  "TZB2401-DS": {
    "headerFields": [
      { "label": "PO Due Date", "value": "17-FEB-2026", "timestamp": "16-FEB-2026 17:00:00" },
      { "label": "Open CAPA Items", "value": "No", "timestamp": "15-FEB-2026 16:30:00" },
      { "label": "Equipment Reserved", "value": "Yes (22 items)", "timestamp": "22-DEC-2025 09:15:00" }
    ],
    "milestones": [
      { "item": "Equipment Reservation Confirmed", "targetDate": "20-DEC-2025", "expectedDate": "20-DEC-2025", "actualDate": "22-DEC-2025", "lastUpdate": "22-DEC-2025 09:15:00" },
      { "item": "Raw Materials Order Placed", "targetDate": "15-DEC-2025", "expectedDate": "15-DEC-2025", "actualDate": "15-DEC-2025", "lastUpdate": "15-DEC-2025 10:30:00" },
      { "item": "Raw Materials Received at CMO", "targetDate": "29-DEC-2025", "expectedDate": "29-DEC-2025", "actualDate": "30-DEC-2025", "lastUpdate": "30-DEC-2025 14:20:00" },
      { "item": "CMO RM Release (QC Approved)", "targetDate": "03-JAN-2026", "expectedDate": "03-JAN-2026", "actualDate": "04-JAN-2026", "lastUpdate": "04-JAN-2026 16:00:00" },
      { "item": "CMO MFG Start (Cell Thaw)", "targetDate": "05-JAN-2026", "expectedDate": "05-JAN-2026", "actualDate": "05-JAN-2026", "lastUpdate": "05-JAN-2026 09:45:00" },
      { "item": "End of Production (EOP Harvest)", "targetDate": "24-JAN-2026", "expectedDate": "24-JAN-2026", "actualDate": "24-JAN-2026", "lastUpdate": "24-JAN-2026 21:00:00" },
      { "item": "Downstream Purification Complete", "targetDate": "30-JAN-2026", "expectedDate": "30-JAN-2026", "actualDate": "30-JAN-2026", "lastUpdate": "30-JAN-2026 20:30:00" },
      { "item": "DS Formulation Complete", "targetDate": "31-JAN-2026", "expectedDate": "31-JAN-2026", "actualDate": "31-JAN-2026", "lastUpdate": "31-JAN-2026 18:00:00" },
      { "item": "DS Aseptic Bag Fill Complete (Mfg Date)", "targetDate": "01-FEB-2026", "expectedDate": "01-FEB-2026", "actualDate": "01-FEB-2026", "lastUpdate": "01-FEB-2026 18:00:00" },
      { "item": "DS Controlled Rate Freeze Complete", "targetDate": "02-FEB-2026", "expectedDate": "02-FEB-2026", "actualDate": "02-FEB-2026", "lastUpdate": "02-FEB-2026 20:00:00" },
      { "item": "DS Transferred to Cold Storage Vault", "targetDate": "02-FEB-2026", "expectedDate": "02-FEB-2026", "actualDate": "02-FEB-2026", "lastUpdate": "02-FEB-2026 21:30:00" },
      { "item": "DS Release Sample Pulled for QC", "targetDate": "07-FEB-2026", "expectedDate": "07-FEB-2026", "actualDate": "07-FEB-2026", "lastUpdate": "07-FEB-2026 09:00:00" },
      { "item": "Release Testing Start (Identity, SEC, CE-SDS)", "targetDate": "08-FEB-2026", "expectedDate": "08-FEB-2026", "actualDate": "08-FEB-2026", "lastUpdate": "08-FEB-2026 08:30:00" },
      { "item": "Release Testing - Process Residuals (HCP, HCD, PAL)", "targetDate": "11-FEB-2026", "expectedDate": "11-FEB-2026", "actualDate": "11-FEB-2026", "lastUpdate": "11-FEB-2026 17:00:00" },
      { "item": "Release Testing - Microbial (Bioburden, LAL)", "targetDate": "13-FEB-2026", "expectedDate": "13-FEB-2026", "actualDate": "13-FEB-2026", "lastUpdate": "13-FEB-2026 16:00:00" },
      { "item": "Release Testing Complete (Potency + ADCC)", "targetDate": "14-FEB-2026", "expectedDate": "14-FEB-2026", "actualDate": "14-FEB-2026", "lastUpdate": "14-FEB-2026 15:00:00" },
      { "item": "Deviation Closures Complete (4 of 4)", "targetDate": "04-FEB-2026", "expectedDate": "04-FEB-2026", "actualDate": "04-FEB-2026", "lastUpdate": "04-FEB-2026 11:30:00" },
      { "item": "Reactive CAPAs / Change Controls Closed", "targetDate": "14-FEB-2026", "expectedDate": "14-FEB-2026", "actualDate": "15-FEB-2026", "lastUpdate": "15-FEB-2026 13:30:00" },
      { "item": "Batch Documentation Compiled", "targetDate": "15-FEB-2026", "expectedDate": "15-FEB-2026", "actualDate": "15-FEB-2026", "lastUpdate": "15-FEB-2026 17:30:00" },
      { "item": "CMO QA Approval (DS CoA Issued)", "targetDate": "15-FEB-2026", "expectedDate": "15-FEB-2026", "actualDate": "16-FEB-2026", "lastUpdate": "16-FEB-2026 10:00:00" },
      { "item": "Sponsor Document Review", "targetDate": "16-FEB-2026", "expectedDate": "16-FEB-2026", "actualDate": "16-FEB-2026", "lastUpdate": "16-FEB-2026 16:00:00" },
      { "item": "Sponsor DS Release (QP Disposition)", "targetDate": "17-FEB-2026", "expectedDate": "17-FEB-2026", "actualDate": "17-FEB-2026", "lastUpdate": "17-FEB-2026 14:00:00" }
    ]
  }
};

const DEFAULT_BATCH = '2388-OXB-A-1';

// Deep-clone a value, replacing every occurrence of the template batch token with
// the actual batch, so an unmapped batch shows representative data carrying its own
// batch number.
const deepReplace = (val, from, to) => {
  if (typeof val === 'string') return val.split(from).join(to);
  if (Array.isArray(val)) return val.map((v) => deepReplace(v, from, to));
  if (val && typeof val === 'object') {
    const o = {};
    Object.keys(val).forEach((k) => { o[k] = deepReplace(val[k], from, to); });
    return o;
  }
  return val;
};

// Pick the Excel dataset for a batch. Known batch -> its own rows; any other
// batch -> the representative (2388) rows remapped to carry that batch number;
// no batch on the row -> the template as-is.
export const selectTabData = (dataMap, batchNumber, defaultBatch = DEFAULT_BATCH) => {
  const key = batchNumber ? String(batchNumber).trim() : '';
  if (key && dataMap[key]) return dataMap[key];
  const base = dataMap[defaultBatch] || [];
  if (key) return deepReplace(base, defaultBatch, key);
  return base;
};

// Is a value "present" (i.e. worth taking from the API instead of the Excel
// fallback)? Empty string / null / undefined / empty object are treated as absent.
const isPresent = (v) => {
  if (v === null || v === undefined) return false;
  if (typeof v === 'string') return v.trim() !== '';
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === 'object') return Object.values(v).some(isPresent);
  return true;
};

// Merge one API row over one Excel row, column by column: keep the API value
// where present, otherwise fall back to the Excel value. Union of both keys.
const mergeRow = (apiRow, excelRow) => {
  if (!apiRow) return excelRow;
  if (!excelRow) return apiRow;
  const out = { ...excelRow };
  Object.keys(apiRow).forEach((k) => { if (isPresent(apiRow[k])) out[k] = apiRow[k]; });
  return out;
};

// Merge two index-aligned row lists: for each row and column the API value wins
// when present, else the Excel value fills in. Rows beyond the shorter list come
// from whichever source has them, so real API data is never dropped and missing
// data is completed from Excel. An empty/absent API list yields the Excel list.
const mergeRows = (apiRows, excelRows) => {
  const api = Array.isArray(apiRows) ? apiRows : [];
  const excel = Array.isArray(excelRows) ? excelRows : [];
  if (api.length === 0) return excel;
  const n = Math.max(api.length, excel.length);
  const out = [];
  for (let i = 0; i < n; i++) out.push(mergeRow(api[i], excel[i]));
  return out;
};

// Merge the API response (data prop) over the Excel dataset for a batch. For each
// row (aligned by index) and each column, the API value wins when present, else the
// Excel value fills in.
export const mergeTabData = (apiRows, dataMap, batchNumber) => {
  return mergeRows(apiRows, selectTabData(dataMap, batchNumber));
};
